// 组件
import newBlindBox from "./lucky-draw-page/new-blind-box/new-blind-box.vue";
import rouletteKoi from "./lucky-draw-page/roulette-koi/roulette-koi.vue";
import bigWheel from "./lucky-draw-page/big-wheel/big-wheel.vue";
import blindBox from "./lucky-draw-page/blind-box/blind-box.vue";
import guideModal from "../dynamicAttr/modal/guideModal";
import resultDialog from "../lucky-draw/components/result-dialog.vue";
import loginIn from "../dynamicAttr/modal/login-in.vue";
import GeneralLottery from "./lucky-draw-page/new-blind-box/general-lottery.vue";
import shareTag from "./components/share-tag.vue";
import storeModal from "./components/store-modal.vue";
import topStoreDisplay from "./components/top-store-display.vue";
import IncorrectClient from "../dynamicAttr/incorrect-client.vue";
import qywxGuideLimitModal from "../dynamicAttr/modal/qywxGuideLimitModal.vue";
import communityUserLimitModal from "../dynamicAttr/modal/communityUserLimitModal.vue";
import { config } from "@/api/config.js";
// 工具
import "jquery";
import wx from "weixin-js-sdk";
import { Dialog, Toast } from "vant";
import {
  BigWheelConstants as BWC,
  PMLinkType,
  DrawRestrictionsFlag
} from "./common/global-variable";
import mixins from "./mixin";
import { loadAlipayWebViewScript } from "../../../../utils/comUtils.js";
import {
  jumpToPointsMall,
  noLoginHandler,
  jumpToMapNavigation,
  checkClient,
  pointsMallLinkJudge,
  userLimitHandler,
  getPosition
} from "../common-methods/utils";
import {
  IdentityVerify,
  ShowOtherActivity,
  CustomerGroup,
  USER_LIMIT_STATUS,
  ActivityType
} from "../../../../commons/commonVariables";
import identityVerifyDialog from "../dynamicAttr/identityVerifyDialog.vue";
export default {
  mixins: [mixins],
  props: {
    activityObj: Object
  },
  components: {
    newBlindBox,
    rouletteKoi,
    bigWheel,
    blindBox,
    guideModal,
    resultDialog,
    loginIn,
    GeneralLottery,
    shareTag,
    storeModal,
    topStoreDisplay,
    [Dialog.Component.name]: Dialog.Component,
    IncorrectClient,
    identityVerifyDialog,
    qywxGuideLimitModal,
    communityUserLimitModal
  },
  data() {
    return {
      isCorrectClient: true, // 是否在正确的客户端打开
      originLoginType: BWC.LoginType.None, // 原始登录类型（转换前）
      BWC: BWC,
      nextFlag: "",
      activityTypeFlag: "1", // 小程序类型 1 => 体验店  2 => 直营店（直营店已下线，该变量为固定值）
      isLoginFlag: false, // 默认没有登录
      isOutDateList: {}, // (实物-线上邮寄)奖品是否超过有效期
      guideLotteryUrl: "", // 引导图
      // regularDrawShowStatus 1.活动结束后,用户有中奖;2.活动结束后,用户未中奖;3.活动已结束,但是用户未参与过活动;
      // 4.活动进行中,用户无次数;5.活动进行中,用户有次数;6.活动已结束,但是活动中奖逻辑还在计算中(开奖中)
      regularDrawShowStatus: "",
      headerList: null, // 参与用户头像
      userNum: null, // 参与抽奖人数
      // 是否是轮盘锦鲤抽奖
      tigerLottery: false,
      // 轮盘锦鲤抽奖类型
      tigerDraw: "3",
      // 轮盘锦鲤第三段颜色
      sectionThreeColor: "",
      // 轮盘锦鲤第二段颜色 #AE7B6E
      tigerBgColor: "",
      // 老虎机抽奖，用户中奖信息展示条数
      tigerWinningListLength: 20,
      // 无缝滚动组件配置项
      classOption: {
        // 开启无缝滚动的数据量
        limitMoveNum: 4,
        // 向左滚动
        direction: 2,
        // 滚动速度，值越大速度越快
        step: 0.8,
        openTouch: true,
        hoverStop: false
      },
      defaultAvatar: window.location.origin + "/static/userImg.png",
      drawWheelUrl: "",
      drawPointUrl: "",
      msg: "",
      turnplate: {
        imgs: [],
        restaraunts: [],
        colors: [],
        outsideRadius: 197,
        textRadius: 155,
        insideRadius: 42,
        startAngle: 0,
        bRotate: false
      },
      winnerList: [], // 全部的中奖记录
      myRecord: [], // 我的中奖记录，包含未中奖的情况
      myRecords: [], // 我的中奖记录，已剔除未中奖的情况
      bigWheelRewardList: [],
      ruleDesc: "",
      bannerPic: "",
      bgColor: "#eee",
      activityCode: "",
      userBase: {}, // 全部的用户信息
      hasNextActivityFlag: false,
      nextActivityCode: "",
      awardObj: {},
      participateTimes: 0, // 剩余抽奖次数，对应后端返回的字段balanceTimes ，后端同名字段（participateTimes）：表示初始化抽奖设置的抽奖机会
      drawType: "", // 获取抽奖次数的方式，具体参照枚举变量BWC.DrawType
      drawPointConsumption: 0,
      balancePonits: 0,
      participateType: "", // 抽奖类型(1 初始化抽奖，2 积分抽奖 3 全部  4 订单抽奖 5 每日抽奖 6 分享抽奖)
      activityStatus: BWC.ActivityStatus.running, // 活动状态 0 未开始 1 进行中 2 暂停中 3 已结束
      reFresh: false,
      canDrawFlag: false, // getDrawInfo 接口返回的 flag 字段：true -> 可以抽奖，false -> 不可以抽奖
      wrapperHeight: 0,
      drawCode: "", //多门店抽奖code
      channelCode: "", //门店编码
      modalShowFlag: false, //是否显示中奖弹窗
      miniprogramFlag: false, //判断是否在小程序打开
      isShowBackBtn: false, //判断是否显示返回按钮
      loginType: "",
      shareType: "",
      memberInfo: {}, // 会员信息
      activityUrl: "", // 当前活动地址
      pointDrawFlag: false, // false -> 可正常抽奖，true -> 当前用户不是会员
      windowHiddenFlag: false, // 页面是否隐藏至后台
      windowShowFlag: false, // 是否打开或回到当前页面
      bigWheelActivityType: BWC.BigWheelActivityType.bigTurnable, // 抽奖类型 1 => 大转盘   2 => 盲盒  3=> 轮盘锦鲤 4 => 新盲盒
      staticImg: [
        "../../../../../static/runtime/images/magic/award/diyModalBg.png",
        "../../../../../static/runtime/images/magic/award/diyModalButton.png",
        "../../../../../static/runtime/images/magic/award/zjjl_tc_bg.png",
        "../../../../../static/runtime/images/magic/award/awardBg3.png",
        "../../../../../static/runtime/images/magic/award/awardBg1.png",
        "../../../../../static/runtime/images/magic/award/awardBg2.png"
      ],
      activityUrlTypel: "", // 多门店时是否产生多条链接 1 => 是   2 => 否
      boxIndex: "", // 当前点击盲盒的标号
      awardNum: 0, // 奖品的个数
      miniType: "1", //小程序类型  1 => 体验店  2 => 直营店（直营店已下线，该变量为固定值）
      winRewardGoods: {}, //奖品记录
      remainingSharingTimes: "", // 分享抽奖，剩余分享次数
      drawWheelType: "", // 大转盘抽奖类型，1：普通抽奖；2：整点购抽奖；3：定时开奖
      winningRate: 0, // 中奖率 （定时抽奖中，如果中奖率 > 1 则会展示）
      hasMask: false, // 定时抽奖 除只配置初始化抽奖情况 控制是否显示遮罩
      whetherActivity: false, // 用户是否参与过活动 true 用户参与过 false 没有参与
      newBlindBoxData: {}, //新盲盒的数据，往组件内部传
      showEndPage: false,
      jumpNextPageType: "", //转盘抽奖后跳转下级页面设置：0抽奖后展示下一级 1抽奖机会=0展示下一级
      userInfoList: [],
      tips: "",
      currentAward: {}, // 当前中奖奖品（新盲盒-普通抽奖，使用）
      geolocation: {}, //new 对象地理信息
      userType: "", // 参与用户类型对象标识：1.荣耀会员 2.全部用户 3.社群用户
      firstDialog: false, // 初始进入页面，弹窗最近一次抽奖记录，用于控制后续不要重复弹窗
      drawStatus: "", // 用户抽奖状态（积分抽奖，开启抽奖次数限制时返回）
      pageDisplayContent: "", // 页面展示文案（积分抽奖，开启抽奖次数限制时返回）
      tipsMessage: "", // 弹窗提示语（积分抽奖，开启抽奖次数限制时返回）
      tipsMessageCode: null, //芝麻身份 学生 教师 医护未验证后台返回1501 或者验证不通过返回1502
      isMemberId: false,
      userId: "", // 用户ID
      from: "", // 用户ID来源，有：APKM
      imgDataObtainDone: false, // 图片数据获取完成
      // 国内地区省份表Id
      regionalId: "",
      // 区域省份表Id
      provincesRegionalId: "",
      // 按时间段配中奖概率
      isTimeSectionLottery: false,
      showGetLocationNotice: false,
      showSelectStoreNotice: false,
      // 多门店活动信息（前置接口bigWheelActivityFront返回）
      multiStoreActivityInfo: {},
      // 活动当前选择的门店
      currentStore: {
        channelCode: "",
        channelName: "",
        gcj02Longitude: "",
        gcj02Latitude: "",
        mobilephone: {
          pid: "",
          hashText: "",
          anonymizedText: ""
        },
        channelAddress: ""
      },
      // 切换门店时，用来计数返回的数量，目前会涉及到6个接口的刷新
      refreshInterfaceCount: 0,
      // 全部待刷新的接口，默认是8个，如果未调用，则做减法
      totalRefreshInterface: 8,
      adminRegions: {}, //行政区域ID对象
      isShowIdentityDialog: false, //是否顾客参加活动的时候身份验证弹框
      raffleVerifyTitle: "", //展示参加大转盘身份验证弹框的内容
      restrictType: "", // 身份限制： 0不限制  2新老用户  999 多方式
      customerIdentity: "", //当前活动的身份
      customerIdentityList: [], // 多方认证身份数组
      mobileVerification: "", //当前顾客手机厂商是老用户还是新用户
      customerIdentityNextUrlConfig: "", //引导客户参与其他活动链接开关, 0关闭, 1开启
      customerIdentityNextUrl: "", //去参加其他活动跳转的URL
      showOtherActivity: false, //是否显示去参加其他活动的按钮
      isShowCheckBtn: false, //是否展示去验证按钮-芝麻身份 学生 医护 教师未验证过则展示
      parentActivityCode: "", //大转盘父级活动code
      isClickNextPage: "false", //是否点击了下级页面
      isFilledFlag: false, // 用于实物+到店自提+无需预约导购+收集消费者信息时，判断是否填写过消费者信息
      ActivityType: ActivityType
    };
  },
  async created() {
    // 大转盘活动点击去参加活动获取参数
    if (
      this.$route.query.activityCode &&
      this.$route.query.parentActivityCode
    ) {
      this.parentActivityCode = this.$route.query.parentActivityCode;
      this.isClickNextPage = "true";
    }
    this.isMemberId = sessionStorage.getItem("isMemberId");
    this.userType = sessionStorage.getItem("userType");
    this.loginType = sessionStorage.getItem("loginType") || "";
    this.shareType = sessionStorage.getItem("shareType") || "";
    const eventTrackingData = JSON.parse(
      sessionStorage.getItem("eventTrackingData") || "{}"
    );
    this.activityCode =
      (this.activityObj && this.activityObj.activityCode) || "";
    this.isLoginFlag =
      sessionStorage.getItem("isLoginFlag") === "true" ? true : false;
    console.log("raffle-main======>", this.isLoginFlag);
    const routeQuery = this.$route.query;
    let code = "";
    if (routeQuery) {
      code = routeQuery.activityCode;
      if (code && code.indexOf("_") > -1) {
        this.drawCode = code;
      }

      // 获取用户ID及来源
      this.userId = routeQuery.userId || "";
      this.from = routeQuery.from || "";
    }
    this.adminRegions =
      JSON.parse(sessionStorage.getItem("adminRegions")) || {};

    // 组装当前地址
    this.activityUrl = location.origin + "/hd/hdmain?activityCode=" + code;
    if (this.from && this.userId) {
      this.activityUrl =
        this.activityUrl + "&from=" + this.from + "&userId=" + this.userId;
    }
    if (
      eventTrackingData &&
      eventTrackingData.storeCode &&
      eventTrackingData.guideUserId
    ) {
      this.activityUrl =
        this.activityUrl +
        "&ay=" +
        eventTrackingData.activityType +
        "&GUID=" +
        eventTrackingData.guideUserId +
        "&SC=" +
        eventTrackingData.storeCode;
    }
    if (this.drawCode) {
      this.channelCode = this.drawCode.split("_")[1];
    }
    let userBase = {};
    let userInfo = sessionStorage.getItem("userInfo");
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      userBase = Object.assign(userBase, userInfo);
    }
    //荣耀推荐官登录信息
    let recommendUserInfo = sessionStorage.getItem("recommendUserInfo");
    if (recommendUserInfo) {
      recommendUserInfo = JSON.parse(recommendUserInfo);
      userBase = Object.assign(userBase, recommendUserInfo);
    }
    this.userBase = userBase;
    this.userBase.userType = sessionStorage.getItem("userType");
    // userType 是抽奖对象（1 -> 荣耀会员，2 -> 全部用户），会员才有积分
    this.userBase.referrFlag =
      this.userBase.userType == BWC.UserType.allUser ? "1" : "0";
    console.log("awardRotate-userBase:", userBase);
    this.getLotty();
    this.getAllData();

    // 判断是否在小程序内-该方法为异步方法，待优化
    this.handleMiniprogramJudge();
    console.log("miniprogramFlag", this.miniprogramFlag);
    const isFromCustomForm = sessionStorage.getItem("isFromCustomForm") || "";
    // 微信浏览器嵌入h5，并且是从自定义表单跳转
    if (
      isFromCustomForm == "1" &&
      !this.miniprogramFlag &&
      this.loginType == BWC.LoginType.Wechat
    ) {
      window.setTimeout(() => {
        sessionStorage.setItem("isFromCustomForm", "");
        console.log(
          "微信浏览器嵌入h5，来自自定义表单跳转来的，重刷大转盘页面->>"
        );
        const path = "/hdmain?activityCode=" + code;
        this.$router.push({
          path: path
        });
        this.$store.commit("base/setIsRouterAlive", false);
        this.$nextTick(() => this.$store.commit("base/setIsRouterAlive", true));
      }, 400);
    }
    // 多门店活动处理，只有登录的情况下才执行
    if (this.isLoginFlag) {
      this.multipleStoreActivityHandler();
    }
  },
  mounted() {
    this.originLoginType = sessionStorage.getItem("originLoginType");
    this.isCorrectClient = checkClient(this.originLoginType);
  },
  computed: {
    // 显示头部门店名称
    showTopStore() {
      return (
        this.multiStoreActivityInfo &&
        this.multiStoreActivityInfo.inStoreParticipationFlag &&
        this.currentStore &&
        this.currentStore.channelCode
      );
    },
    // 老虎机抽奖，用户中奖信息,只取前20条数据
    tigerWinningList() {
      if (this.winnerList.length > this.tigerWinningListLength) {
        return this.winnerList.slice(0, this.tigerWinningListLength + 1);
      } else {
        return this.winnerList;
      }
    },
    // 是否需要预约导购
    isGuideFlag() {
      return this.winRewardGoods.appointmentFlag === BWC.appointmentFlag.need;
    },
    ruleDesci: function() {
      if (this.ruleDesc) {
        if (this.ruleDesc.indexOf("<a href=") != -1) {
          this.ruleDesc = this.ruleDesc.replace(
            /<a [^>]*href=['"]([^'"]+)[^>]*>/g,
            function(match, capture) {
              const result = capture;
              return (
                "<a href=" +
                result +
                ' rel="noopener noreferrer" target="_blank">'
              );
            }
          );
        }
        return this.ruleDesc
          .replace(/↵/g, "<br/>")
          .replace(/\n/g, "<br/>")
          .replace(/ihlp/g, "hd");
      }
    },
    poinsOrDiamonds: function() {
      return "积分";
    },
    pointsValue() {
      if (this.memberInfo && this.memberInfo.pointsValue) {
        return String(this.memberInfo.pointsValue).replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        );
      } else {
        return "0";
      }
    },
    activityTime() {
      const activityStartTime =
        this.activityObj && this.activityObj.activityStartTime
          ? this.activityObj.activityStartTime.replace(
              /(\d{4}).(\d{1,2}).(\d{1,2}).+/gm,
              "$1年$2月$3日"
            )
          : "";
      const activityEndTime =
        this.activityObj && this.activityObj.activityEndTime
          ? this.activityObj.activityEndTime.replace(
              /(\d{4}).(\d{1,2}).(\d{1,2}).+/gm,
              "$1年$2月$3日"
            )
          : "";
      return activityStartTime + " - " + activityEndTime;
    },
    getButtonBgStyle() {
      return {
        "border-color":
          this.activityObj.extendConfig.awardListButtonColor || "#ffffff",
        color: this.activityObj.extendConfig.awardListButtonColor || "#ffffff"
      };
    },
    modalButtonText() {
      return this.getjumpText();
    },
    // 展示剩余分享次数
    showShareTag() {
      // 新盲盒定时抽奖样式不展示
      if (
        this.drawWheelType === BWC.DrawWheelType.timedDraw &&
        this.bigWheelActivityType === BWC.BigWheelActivityType.newBlindBox
      ) {
        return false;
      } else {
        return (
          this.activityObj.shareFlag === "1" &&
          this.activityObj.activityStatus === BWC.ActivityStatus.running &&
          this.activityObj.extendConfig.participateType &&
          this.activityObj.extendConfig.participateType.indexOf("6") >= 0
        );
      }
    },
    // 是否是多门店公用一条的活动
    isMultiStoreInOneLink() {
      return this.multiStoreActivityInfo.inStoreParticipationFlag === true;
    }
  },
  watch: {
    myRecord: {
      deep: true,
      handler(newVal) {
        if (newVal && !this.firstDialog) {
          // participateTimes有没有抽奖机会  whetherActivity有没有玩过活动 hasNextActivityFlag有没有下级页面 modalShowFlag有没有显示中奖弹窗
          // 抽奖机会=0，展示下一级 || 抽奖后，展示下一级
          if (
            (!this.participateTimes &&
              this.whetherActivity &&
              this.hasNextActivityFlag &&
              this.jumpNextPageType === "1") ||
            (this.whetherActivity &&
              this.hasNextActivityFlag &&
              this.jumpNextPageType === "0")
          ) {
            this.initOpenDialog();
            this.firstDialog = true;
          }
        }
      }
    },
    // 监听已刷新完成的接口，和总共需要刷新的接口数做对比，若相等，则清楚loading状态
    refreshInterfaceCount: {
      handler(val) {
        if (val === this.totalRefreshInterface) {
          Toast.clear();
        }
      }
    }
  },
  methods: {
    // 针对芝麻学生 医护 教师身份 抽奖按钮是灰色时，修改子组件值
    updateIsShowIdentityDialog() {
      this.isShowIdentityDialog = true;
      if (this.tipsMessageCode === 1502) {
        this.isShowCheckBtn = false;
      }
    },
    // 跳转中奖名单页
    goWinnerList() {
      const path = `/winnerList?activityCode=${this.activityObj.activityCode}&openId=${this.userBase.openId}&channelCode=${this.channelCode}&isUsed=${this.activityObj.isUsed}`;
      this.$router.push({
        path: path
      });
    },
    // 查询会员信息
    queryMemberInfo() {
      const params = {
        uniqId: this.userBase.unionid || "",
        idType: this.loginType == BWC.LoginType.Wechat ? "1" : "6"
      };
      this.$api.post({
        noLoading: true,
        sc: "member2",
        url: "memberInfoMiniManage/queryMemberInfoByUnionIdAndIdType",
        params,
        success: res => {
          this.refreshInterfaceCount++;
          this.memberInfo = res.result || {};
        },
        failure: err => {
          this.refreshInterfaceCount++;
          Dialog.alert({
            title: "提示",
            message: "活动过于火爆，请稍后再试"
          });
        }
      });
    },
    async getAllData() {
      const self = this;
      // 从门店导航跳转过来，取的门店编码
      if (!this.channelCode && this.activityObj.isUsed === BWC.isUsed.yes) {
        this.channelCode = sessionStorage.getItem("navChannelCode");
      }
      // 校验是否是多门店大转盘
      // 首先查找activityCode，没找到返回FALSE，
      // 找到activityCode，进一步查找channelCode
      // 不传channelCode且大转盘不属于多门店活动，返回TRUE
      // 传了channelCode，并且当前channelCode在配置的多门内，返回TRUE
      const data = await self.checkLottyChannel(
        this.activityObj.activityCode,
        this.channelCode
      );
      // 1.未找到大转盘活动，2.或大转盘是多门店活动，但是没有传channelCode，3.或大转盘是多门店活动，channelCode不在配置门店范围内
      if (!data.result) {
        self.modalShowFlag = true;
        Dialog.confirm({
          title: "提示",
          message: "当前门店不在抽奖活动范围内！"
        }).then(() => {
          if (this.jumpNextPageType) {
            self.hasNextActivityFlag = true;
            self.nextStep();
          }
        });
      }
      // 当前抽奖活动被活动编排引用，且存在活动编排的activityCode
      // 未登录场景下不查改接口，以免提示错误信息
      if (
        this.activityObj.isUsed === BWC.isUsed.yes &&
        sessionStorage.getItem("associationActivityCode") &&
        this.isLoginFlag &&
        this.userBase.openId
      ) {
        // 判断能否抽奖
        const data2 = await self.checkLottyTimes();
        if (!data2.result) {
          self.modalShowFlag = true;
          Dialog.confirm({
            title: "提示",
            message: "您已达到本次抽奖活动的最大抽奖次数,感谢您的支持！"
          }).then(() => {
            if (this.jumpNextPageType) {
              self.hasNextActivityFlag = true;
              self.nextStep();
            }
          });
        }
      } else {
        this.totalRefreshInterface--;
      }

      function getChance() {
        let activityCode = self.drawCode || self.activityObj.activityCode;
        if (
          !self.drawCode &&
          self.activityObj.isUsed === BWC.isUsed.yes &&
          self.activityObj.channelFlag === "2" &&
          sessionStorage.getItem("associationActivityCode") &&
          sessionStorage.getItem("navChannelCode") &&
          self.activityObj.activityUrlTypel == "1"
        ) {
          activityCode = `${
            self.activityObj.activityCode
          }_${sessionStorage.getItem("navChannelCode")}`;
        }
        return new Promise(resolve => {
          self.$api.post({
            noLoading: true,
            sc: "mobileMarketing",
            url: "h5/bigWheel/getDrawInfo",
            params: {
              activityCode: activityCode,
              openId:
                self.loginType == BWC.LoginType.Wechat
                  ? self.userBase.openId || ""
                  : "",
              unionid:
                self.loginType == BWC.LoginType.Wechat
                  ? self.userBase.unionid || ""
                  : "",
              alipayUserId:
                self.loginType == BWC.LoginType.Alipay
                  ? sessionStorage.getItem("alipayUserId") || ""
                  : "",
              loginType: self.loginType || "",
              loginSide:
                self.loginType === BWC.LoginType.Wechat
                  ? "wxapp"
                  : self.loginType === BWC.LoginType.Alipay
                  ? "alipaymini"
                  : "",
              referrFlag: self.userBase.referrFlag
                ? self.userBase.referrFlag
                : 0,
              channelCode: self.channelCode,
              memberCode: self.userBase.memberCenterId
            },
            success: r => {
              self.refreshInterfaceCount++;
              resolve(r);
              if (r && r.result && r.result.tips) {
                self.tips = r.result.tips;
              } else {
                self.tips = "";
              }
              if (r && r.code === 200 && r.result && r.result.code >= 0) {
                if (r.result.code === 1501 || r.result.code === 1502) {
                  self.isShowIdentityDialog = true;
                  self.raffleVerifyTitle = r.result.message;
                  self.showOtherActivity = r.result.customerIdentityNextPath
                    ? true
                    : false;
                  self.customerIdentityNextUrl =
                    r.result.customerIdentityNextPath;
                  if (r.result.code === 1501) {
                    self.isShowCheckBtn = true;
                  } else {
                    self.isShowCheckBtn = false;
                  }
                } else if (r.result.code === 0) {
                  Toast(r.result.message);
                }
              }
              const isClickNextPage = sessionStorage.getItem("isClickNextPage"); //为true说明跳小程序之前点击跳转了其他活动，小程序回到h5以后在父级页面自动跳转其他活动
              sessionStorage.removeItem("isClickNextPage");
              if (isClickNextPage === "true") {
                self.goOtherActivity();
              }
            },
            failure: err => {
              self.refreshInterfaceCount++;
              Dialog.alert({
                title: "提示",
                message: "活动过于火爆，请稍后再试"
              });
            }
          });
        });
      }
      console.log("大转盘查看数据", this.userBase);
      if (this.userBase.member) {
        const res = await getChance();
        if (res && res.result) {
          const result = res.result;
          self.participateTimes = result.balanceTimes || 0;
          self.drawPointConsumption = Number(result.drawPointConsumption);
          self.drawType = result.drawType;
          self.canDrawFlag = result.flag;
          self.participateType = result.participateType;
          self.balancePonits = result.balancePonits;
          this.drawStatus = result.status;
          this.pageDisplayContent = result.copywriting;
          this.tipsMessage = result.message;
          // 芝麻身份学生 医护 教师会返回1501 1502 的code
          this.tipsMessageCode = result.code;
          // 获取会员信息
          this.queryMemberInfo();
          // drawRestrictionsFlag 抽奖限制 1：活动期间累计抽奖次数限制，2：活动期间每天抽奖限制 1的才会有弹框 2的就没有
          if (
            result.balanceTimes == "0" &&
            result.totalBalanceTimes > 0 &&
            result.drawType === BWC.DrawType.OrderDraw &&
            result.drawRestrictionsFlag == DrawRestrictionsFlag.cumulativeTimes
          ) {
            Dialog.alert({
              title: "提示",
              message: "您已达到每天抽奖次数，请您明天再来！"
            });
          }
        } else {
          this.totalRefreshInterface--;
        }
      } else {
        this.totalRefreshInterface--;
        this.pointDrawFlag = true;
      }
      if (this.isLoginFlag) {
        this.getRecord();
      } else {
        this.totalRefreshInterface -= 2;
      }
    },
    // 进入抽奖页面之后，若之前有抽奖记录（包括未中奖）则对最近的一次抽奖记录进行弹窗
    initOpenDialog() {
      this.isFilledFlag = false;
      const myAward = this.myRecord[0];
      // singleFlag：表示当前奖品是否有配置下级跳转页面
      this.awardObj = Object.assign({ singleFlag: true }, myAward);
      if (this.awardObj.collectionType !== BWC.CollectionType.freeOfCharge) {
        this.awardObj.drawOrderSource = null;
      }
      this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
      // 未中奖
      if (myAward && myAward.rewardType === BWC.GoodsType.noAward) {
        this.$refs.resultDialog.$refs.noAwardModal.openModel();
      } else if (myAward && myAward.rewardType === BWC.GoodsType.virtualAward) {
        // 虚拟奖品
        // 线下核销2、线下核销发卡密3，免单抽奖4
        if (
          [
            BWC.CollectionType.inStore,
            BWC.CollectionType.checkOffStrCode,
            BWC.CollectionType.freeOfCharge
          ].includes(myAward.collectionType)
        ) {
          this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
            flag: true,
            codeId: this.awardObj.exchangeActivationCodeId,
            type: myAward.collectionType,
            ...this.awardObj
          });
        } else {
          // 1 线上兑换、5 货柜自取
          // 已填写姓名手机号就弹出兑换码，没填就弹窗录入姓名手机号
          if (myAward.rewardRecordextendConfigPrivacy) {
            this.$refs.resultDialog.$refs.virtualAwardModal.openModel();
          } else {
            this.userInfoList = myAward.userInfoList || [];
            //没有展示虚拟客户需要录入信息的弹框
            this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel();
          }
        }
      } else if (myAward && myAward.rewardType === BWC.GoodsType.entityAward) {
        if (myAward.userInfoList === null) {
          // 实物奖品
          let extendConfig = myAward.extendConfig || {};
          if (myAward.extendConfigFlag) {
            // 用户已填写信息，将接口返回的信息进行JSON解析
            extendConfig = JSON.parse(myAward.extendConfig);
          }
          //  获取用户已填写的信息
          if (myAward.rewardRecordextendConfigPrivacy) {
            extendConfig.userName =
              myAward.rewardRecordextendConfigPrivacy.userName;
            extendConfig.userPhone =
              myAward.rewardRecordextendConfigPrivacy.userPhone;
            extendConfig.userAddress =
              myAward.rewardRecordextendConfigPrivacy.userAddress;
          }
          this.awardObj = Object.assign(extendConfig, myAward);
        }
        this.awardObj.singleFlag = true;
        this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
        // 实物-到店自提2
        if ([BWC.CollectionType.inStore].includes(myAward.collectionType)) {
          // 预约导购为否0 并且 是否收集消费者信息为是，需要根据配置显示弹出填写消费者信息
          if (
            myAward.appointmentFlag === BWC.appointmentFlag.noNeed &&
            myAward.userInfoList &&
            myAward.userInfoList.length > 0
          ) {
            if (myAward.rewardRecordextendConfigPrivacy) {
              // 如果已填写消费者信息，进入抽奖页面直接回显展示
              this.userInfoList =
                myAward.rewardRecordextendConfigPrivacy.userInfoList || [];
              this.isFilledFlag = true;
            } else {
              // 如果未填写消费者信息，根据配置展示去填写
              this.userInfoList = myAward.userInfoList || [];
            }
            this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel();
          } else {
            this.$refs.resultDialog.$refs.receiveAwardModal.openModel({
              flag: this.awardObj.appointmentFlag === BWC.appointmentFlag.need,
              codeId: this.awardObj.exchangeActivationCodeId,
              type: myAward.collectionType,
              ...this.awardObj
            });
          }
        } else {
          this.$refs.resultDialog.$refs.kindAwardModal.openModel();
        }
      } else if (
        myAward &&
        [BWC.GoodsType.coupon, BWC.GoodsType.voucher].includes(
          myAward.rewardType
        )
      ) {
        // 优惠券、代金券
        if (myAward.goodsPictureUrl) {
          const pic = JSON.parse(myAward.goodsPictureUrl);
          const imgItem = this.$utils.getImageUrl(pic.file);
          this.awardObj.imgItem = imgItem;
        }
        if (myAward.voucherStartDate && myAward.voucherEndDate) {
          this.awardObj.voucherStartDate = myAward.voucherStartDate;
          this.awardObj.voucherEndDate = myAward.voucherEndDate;
        }
        console.log("------------this.awardObj---------", this.awardObj);
        this.$refs.resultDialog.$refs.couponModal.openModel();
      } else if (
        myAward &&
        myAward.rewardType === BWC.GoodsType.accumulatePoints
      ) {
        // 积分
        this.$refs.resultDialog.$refs.pointModal.openModel();
      } else if (myAward && myAward.rewardType === BWC.GoodsType.giftCoupon) {
        // 赠品券
        this.awardObj.collectionType = "2";
        // 赠品券
        this.awardObj.singleFlag = true;
        this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
        this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
          flag: true,
          codeId: this.awardObj.exchangeActivationCodeId,
          type: myAward.collectionType,
          ...this.awardObj
        });
      }
    },
    getChance() {
      const self = this;
      if (!self.channelCode && self.activityObj.isUsed === BWC.isUsed.yes) {
        self.channelCode = sessionStorage.getItem("navChannelCode");
      }
      let activityCode = self.drawCode || self.activityObj.activityCode;
      if (
        !self.drawCode &&
        self.activityObj.isUsed === BWC.isUsed.yes &&
        self.activityObj.channelFlag === "2" &&
        sessionStorage.getItem("associationActivityCode") &&
        sessionStorage.getItem("navChannelCode") &&
        self.activityObj.activityUrlTypel == "1"
      ) {
        activityCode = `${
          self.activityObj.activityCode
        }_${sessionStorage.getItem("navChannelCode")}`;
      }
      self.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: "h5/bigWheel/getDrawInfo",
        params: {
          activityCode: activityCode,
          openId:
            self.loginType == BWC.LoginType.Wechat
              ? self.userBase.openId || ""
              : "",
          unionid:
            self.loginType == BWC.LoginType.Wechat
              ? self.userBase.unionid || ""
              : "",
          alipayUserId:
            self.loginType == BWC.LoginType.Alipay
              ? sessionStorage.getItem("alipayUserId") || ""
              : "",
          loginType: self.loginType || "",
          loginSide:
            self.loginType === BWC.LoginType.Wechat
              ? "wxapp"
              : self.loginType === BWC.LoginType.Alipay
              ? "alipaymini"
              : "",
          referrFlag: self.userBase.referrFlag ? self.userBase.referrFlag : 0,
          channelCode: self.channelCode,
          memberCode: self.userBase.memberCenterId
        },
        success: r => {
          if (r && r.result) {
            const result = r.result;
            self.participateTimes = result.balanceTimes || 0;
            self.drawPointConsumption = Number(result.drawPointConsumption);
            self.drawType = result.drawType;
            self.canDrawFlag = result.flag;
            self.balancePonits = result.balancePonits;
            self.tips = result.tips || "";
            this.drawStatus = result.status;
            this.pageDisplayContent = result.copywriting;
            this.tipsMessage = result.message;
            // 判断是否是会员，是则获取会员信息，否则页面给出入会提示
            if (this.userBase.member) {
              this.queryMemberInfo();
            } else {
              this.pointDrawFlag = true;
            }
            // drawRestrictionsFlag 抽奖限制 1：活动期间累计抽奖次数限制，2：活动期间每天抽奖限制 1的才会有弹框 2的就没有
            if (
              result.balanceTimes == "0" &&
              result.totalBalanceTimes > 0 &&
              result.drawType === BWC.DrawType.OrderDraw &&
              result.drawRestrictionsFlag ==
                DrawRestrictionsFlag.cumulativeTimes
            ) {
              Dialog.alert({
                title: "提示",
                message: "您已达到每天抽奖次数，请您明天再来！"
              });
            }
          }
        }
      });
    },
    // 查询抽奖页面信息，如活动名称，背景图片，奖品信息，登录类型（微信，支付宝）等
    getLotty() {
      const self = this;
      this.$api.post({
        sc: "mobileMarketing",
        url: "h5/bigWheel/queryActivityBigWheelActivityDetailH5",
        params: {
          activityCode: this.activityObj.activityCode,
          userOpenid:
            self.loginType === BWC.LoginType.Wechat
              ? self.userBase.openId || ""
              : "",
          alipayUserId:
            self.loginType === BWC.LoginType.Alipay
              ? sessionStorage.getItem("alipayUserId") || ""
              : "",
          channelCode: this.channelCode
        },
        success: async r => {
          this.refreshInterfaceCount++;
          const { result, code } = r;
          if (code == 200 && result) {
            this.newBlindBoxData = result;
            const {
              extendConfigStr,
              activityStatus,
              activityPictureUrl,
              drawWheelUrl,
              drawPointUrl,
              bigWheelRewardList,
              bigWheelActivityType,
              activityUrlTypel,
              regularDrawShowStatus,
              headerList,
              userNum,
              userWinNum,
              remainingSharingTimes,
              guideLotteryUrl,
              winningRate,
              whetherActivity,
              activityConfig,
              userLimitStatus
            } = result;
            const timeFlag = activityConfig && activityConfig.timeFlag;
            this.isTimeSectionLottery = timeFlag === BWC.TimeFlag.open;
            this.winningRate = winningRate || 0; // 中奖率
            this.regularDrawShowStatus = regularDrawShowStatus; // 定时开奖状态
            this.whetherActivity = whetherActivity; // 用户是否参与过活动
            this.activityObj.activityConfig = activityConfig;
            this.restrictType = activityConfig.restrictType;
            this.userLimitStatus = userLimitStatus;
            if (
              activityConfig.restrictType ===
              CustomerGroup.multimodalVerification
            ) {
              this.customerIdentityList = activityConfig.userAuthenticationValue.split(
                ","
              ); //当前顾客身份 0:不限制；3-2:芝麻身份-老师；3-1:学生；3-3:医护；2-1:老用户；2-2:新用户
            } else {
              this.customerIdentity = activityConfig.userAuthenticationValue;
            }
            this.customerIdentityNextUrlConfig =
              activityConfig.customerIdentityNextUrlConfig; //顾客身份拦截后,引导客户参与其他活动链接开关, 0关闭, 1开启
            if (this.customerIdentityNextUrlConfig === "1") {
              this.showOtherActivity = true;
            }
            this.customerIdentityNextUrl =
              activityConfig.customerIdentityNextUrl; //参加其他活动的Url字段
            if (
              this.loginType !== "none" &&
              this.isLoginFlag &&
              [
                USER_LIMIT_STATUS.QY_WECHAT_GUIDE_TIME_LIMIT,
                USER_LIMIT_STATUS.COMMUNITY_USER_TIME_LIMIT,
                USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT,
                USER_LIMIT_STATUS.NOT_ADD_QY_WECHA_GUIDE_LIMIT,
                USER_LIMIT_STATUS.NOT_ADD_COMMUNITY_LIMIT
              ].includes(userLimitStatus) &&
              activityStatus === BWC.ActivityStatus.running
            ) {
              // 抽奖对象首先是会员，而且要登录状态，userLimitStatus为用户身份限制状态
              userLimitHandler(
                userLimitStatus,
                ActivityType.bigTurnable,
                this.activityObj.activityConfig,
                "parent",
                this
              );
            }
            if (whetherActivity) {
              this.hasMask = true;
            } else {
              this.hasMask = false;
            }
            this.headerList = headerList;
            this.userNum = userNum;
            this.userWinNum = userWinNum;
            this.remainingSharingTimes = remainingSharingTimes; //剩余分享次数
            this.headerList &&
              this.headerList.length > 5 &&
              (this.headerList.length = 5);
            this.guideLotteryUrl = guideLotteryUrl
              ? this.$utils.getImageUrl(JSON.parse(guideLotteryUrl).file)
              : null;
            // 奖品池数组
            this.bigWheelRewardList = bigWheelRewardList;
            // 抽奖类型 bigWheelActivityType 1 => 大转盘   2 => 盲盒  3 => 轮盘锦鲤   4 =.新盲盒
            this.bigWheelActivityType = bigWheelActivityType;
            // 是否为老虎机抽奖（轮盘锦鲤）
            this.tigerLottery =
              bigWheelActivityType === this.tigerDraw ? true : false;
            // 多门店时是否产生多条链接 1 => 是   2 => 否
            this.activityUrlTypel = activityUrlTypel;
            //大转盘抽奖类型，1：普通抽奖；2：整点购抽奖；3：定时开奖
            this.drawWheelType = result.drawWheelType;
            if (activityConfig) {
              const { ruleDescri, ruleDescriUrl } = activityConfig;
              // 此方法下载并读取活动公告，公告不再在详情接口直接返回，而是返回公告文件链接，前端下载读取显示
              this.downloadAndReadTextFile(ruleDescriUrl, ruleDescri);
            }
            if (extendConfigStr) {
              const extendConfig = JSON.parse(extendConfigStr);
              const {
                bgColor,
                participateType,
                jumpNextPageType
              } = extendConfig;
              this.bgColor = bgColor;
              this.jumpNextPageType = jumpNextPageType; //转盘抽奖后跳转下级页面设置：0抽奖后展示下一级 1抽奖机会=0展示下一级
              if (this.tigerLottery) {
                this.sectionThreeColor = bgColor;
              }
              if (this.jumpNextPageType) {
                this.hasNextActivityFlag = true;
              }
              if (participateType) {
                this.isShowBackBtn =
                  participateType.indexOf("4") > -1 ? true : false;
              }
            }
            if (activityStatus === BWC.ActivityStatus.running) {
              if (whetherActivity) {
                this.showEndPage = true;
              } else {
                this.showEndPage = false;
              }
            } else if (activityStatus === BWC.ActivityStatus.finished) {
              this.showEndPage = true;
            }

            this.activityStatus = activityStatus;
            if (activityPictureUrl) {
              this.bannerPic = this.$utils.getImageUrl(
                JSON.parse(activityPictureUrl).file
              );
              this.staticImg.push(this.bannerPic);
            }
            if (drawWheelUrl) {
              this.drawWheelUrl = this.$utils.getImageUrl(
                JSON.parse(drawWheelUrl).file
              );
              this.staticImg.push(this.drawWheelUrl);
            }
            if (drawPointUrl) {
              this.drawPointUrl = this.$utils.getImageUrl(
                JSON.parse(drawPointUrl).file
              );
              this.staticImg.push(this.drawPointUrl);
            }
            const len = bigWheelRewardList.length;
            // 奖品重置
            this.awardNum = 0;
            for (let i = 0; i < len; i++) {
              this.turnplate.restaraunts[i] = "";
              this.turnplate.colors[i] = bigWheelRewardList[i].bgColor;
              if (bigWheelRewardList[i].goodsType != BWC.GoodsType.noAward) {
                this.awardNum++;
              }
              if (bigWheelRewardList[i].goodsPictureUrl) {
                const pic = JSON.parse(bigWheelRewardList[i].goodsPictureUrl);
                const imgItem = this.$utils.getImageUrl(pic.file);
                this.bigWheelRewardList[i].imgUrl = imgItem;
                this.turnplate.imgs[i] = imgItem;
              } else {
                this.turnplate.imgs[
                  i
                ] = require("../../../../../static/runtime/images/magic/award/zp_zjzl.png");
              }
            }
            this.imgDataObtainDone = true;
            // getOldCustomerBrand 这个接口必须在登录后才有数据，登录前接口403，会阻塞详情加载，所以要放在大转盘详情加载出来后执行
            if (
              this.restrictType === CustomerGroup.newOldUser &&
              (this.customerIdentity === IdentityVerify.oldUser ||
                this.customerIdentity === IdentityVerify.newUser)
            ) {
              await this.getOldCustomerBrand();
              if (this.mobileVerification === this.customerIdentity) {
                // 当前用户身份（新老）与配置相符
                this.isShowIdentityDialog = false;
              } else if (this.miniprogramFlag) {
                // 当前用户身份（新老）与配置不符且在小程序环境打开（小程序可以获取到设备信息判断新老用户）
                this.isShowIdentityDialog = true;
                this.raffleVerifyTitle =
                  this.customerIdentity === IdentityVerify.newUser
                    ? "您是老用户无法参与当前活动"
                    : "您是新用户无法参与当前活动";
              }
            } else {
              this.totalRefreshInterface--;
            }
          } else {
            Dialog.alert({
              message: "查询活动详情失败"
            });
          }
        },
        failure: () => {
          this.refreshInterfaceCount++;
        }
      });
    },

    async downloadAndReadTextFile(ruleDescriUrl, ruleDescri) {
      console.log("公告url和内容", ruleDescriUrl, ruleDescri);
      if (
        !ruleDescriUrl ||
        ruleDescriUrl == " " ||
        ruleDescriUrl == "" ||
        ruleDescriUrl == null ||
        ruleDescriUrl == undefined
      ) {
        // 各种不存在的url情况
        this.ruleDesc = ruleDescri;
        return;
      }
      // const aaa = "https://hd-sit1.test.hihonor.com/mobileZuul/integration/spuImage/miniTxtLoad?url=marking/upload/2024-12-25/eb2f87a483ab45dbab75bebe44fbd562.txt";
      try {
        const url = `${config.hdBaseUrl}/mobileZuul/integration/spuImage/miniTxtLoad?url=${ruleDescriUrl}`;
        // 使用 fetch API 下载文件
        const response = await fetch(url);
        // 检查响应是否成功
        if (response.status === 200) {
          // 读取文件内容
          const text = await response.text();
          try {
            const obj = JSON.parse(text);
            if (obj && obj.code == 500 && obj.message) {
              // 请求成功了但没有返回结果
              this.ruleDesc = ruleDescri;
            } else {
              this.ruleDesc = text;
            }
          } catch (err) {
            this.ruleDesc = text;
          }
          console.log("下载和读取公告成功:", text);
        } else {
          this.ruleDesc = ruleDescri;
        }
      } catch (error) {
        this.ruleDesc = ruleDescri;
        console.log("下载或读取公告出错:", error);
      }
    },
    /**
     * 获取老用户手机厂商
     */
    getOldCustomerBrand() {
      // 接口返回老用户手机厂商列表
      let oldUserPhoneList = JSON.parse(
        sessionStorage.getItem("oldUserPhoneList")
      );
      let deviceBrand = sessionStorage.getItem("deviceBrand");
      // 这个变量用来存储当前顾客手机厂商是老用户，还是新用户，老用户存储2-1，新用户存储2-2
      this.mobileVerification =
        sessionStorage.getItem("mobileVerification") || "";
      if (!oldUserPhoneList || !this.mobileVerification) {
        return new Promise(resolve => {
          this.$api.post({
            sc: "mobileMarketing",
            url: "/miniCouponManager/obtainOldCustomerBrand",
            params: {},
            success: r => {
              this.refreshInterfaceCount++;
              console.log("老用户厂商", r);
              if (r.code == 200 && r.result) {
                // 这个接口返回的都是老用户厂商列表
                oldUserPhoneList = r.result.map(item => {
                  return item.toLowerCase();
                });
                if (oldUserPhoneList.includes(deviceBrand)) {
                  // 表示老用户
                  this.mobileVerification = IdentityVerify.oldUser;
                } else {
                  // 表示新用户
                  this.mobileVerification = IdentityVerify.newUser;
                }
                sessionStorage.setItem(
                  "mobileVerification",
                  this.mobileVerification
                );
                sessionStorage.setItem(
                  "oldUserPhoneList",
                  JSON.stringify(oldUserPhoneList)
                );
              }
              resolve();
            },
            failure: () => {
              this.refreshInterfaceCount++;
              reject("未获取老用户厂商列表");
            }
          });
        });
      }
    },
    // 获取查询我的中奖记录、滚动栏中奖记录（全部中奖记录）的入参
    getRecordParams() {
      if (!this.channelCode && this.activityObj.isUsed === BWC.isUsed.yes) {
        this.channelCode = sessionStorage.getItem("navChannelCode");
      }
      return {
        activityCode: this.activityObj.activityCode,
        userOpenid:
          this.loginType == BWC.LoginType.Wechat
            ? this.userBase.openId || ""
            : "",
        alipayUserId:
          this.loginType == BWC.LoginType.Alipay
            ? sessionStorage.getItem("alipayUserId") || ""
            : "",
        loginType: this.loginType || "",
        channelCode: this.channelCode
      };
    },
    // 获取用户的中奖记录
    getUserRewardRecords(currentAwardRefresh = false) {
      const tmp = [];
      this.isFilledFlag = false;
      this.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: "h5/bigWheel/reward/record/all/getRecordDetail",
        params: this.getRecordParams(),
        success: res => {
          this.refreshInterfaceCount++;
          if (res.code === 200) {
            const list =
              (res.result && res.result.bigwheelRewardRecordDetailsDtoList) ||
              [];
            if (list.length > 0) {
              // 用户全部的中奖记录，包括未中奖
              this.myRecord = JSON.parse(JSON.stringify(list));
              this.myRecord.filter(item => {
                if (item.rewardType !== BWC.GoodsType.noAward) {
                  tmp.push(item);
                }
              });
              this.myRecords = tmp;
              if (currentAwardRefresh) {
                //新盲盒-普通抽奖， 更新当前奖品，然后调用子组件方法，进行抽奖处理
                const tmp =
                  this.myRecord.filter(
                    item =>
                      item.bigwheelRewardRecodeId === this.currentAward.recordId
                  )[0] || {};
                this.currentAward = Object.assign(tmp, this.currentAward);
                // 实物+到店自提+预约导购为否0 并且 是否收集消费者信息为是，需要根据配置显示弹出填写消费者信息
                if (
                  this.currentAward.rewardType === BWC.GoodsType.entityAward &&
                  this.currentAward.collectionType ===
                    BWC.CollectionType.inStore &&
                  this.currentAward.appointmentFlag ===
                    BWC.appointmentFlag.noNeed &&
                  this.currentAward.userInfoList &&
                  this.currentAward.userInfoList.length > 0
                ) {
                  this.awardObj = Object.assign({}, this.currentAward);
                  this.awardObj.writeOffCodeUrl = "";
                  this.awardObj.bigWheelActivityType = Number(
                    this.bigWheelActivityType
                  );
                  if (this.currentAward.rewardRecordextendConfigPrivacy) {
                    // 如果已填写消费者信息，进入抽奖页面直接回显展示
                    this.userInfoList =
                      this.currentAward.rewardRecordextendConfigPrivacy
                        .userInfoList || [];
                    this.isFilledFlag = true;
                  } else {
                    // 如果未填写消费者信息，根据配置展示去填写
                    this.userInfoList = this.currentAward.userInfoList || [];
                  }
                  this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel();
                } else {
                  this.$refs.generalLotteryRef.winningAwardsHandler(
                    this.currentAward
                  );
                }
              }
              // （实物&&线上邮寄）奖品是否超过有效期
              this.isOutDateList = {};
              list.forEach(el => {
                this.isOutDateList[
                  el.bigwheelRewardRecodeId
                ] = el.effectiveEndTime
                  ? new Date() > new Date(el.effectiveEndTime)
                  : false;
              });
            } else {
              // 没有中奖记录，清空数组
              this.myRecord = [];
              this.myRecords = [];
            }
          } else {
            Dialog.alert({
              message: res.message || "获取用户中奖记录失败"
            });
          }
        },
        failure: err => {
          this.refreshInterfaceCount++;
          Dialog.alert({
            message: err.message || "获取用户中奖记录失败"
          });
        }
      });
    },
    // 获取全部中奖记录
    getAllRewardRecords() {
      this.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: "h5/bigWheel/reward/record/all/getFullList",
        params: this.getRecordParams(),
        success: res => {
          this.refreshInterfaceCount++;
          if (res.code === 200) {
            const list = res.result && res.result.bigwheelRewardRecordDtoList;
            if (list.length > 0) {
              // 处理隐私信息
              this.$utils.addAnonymizedText(list, ["nickName"]);
              this.winnerList = JSON.parse(JSON.stringify(list));
              // prizeWinningScrollFlag 1: '按全量的中奖展示', 0: '按中奖滚动展示'
              if (
                this.activityObj.prizeWinningScrollFlag ==
                BWC.prizeWinningScrollFlag.display
              ) {
                setTimeout(() => {
                  this.winnerList = JSON.parse(JSON.stringify(list));
                }, 0);
              }
            } else {
              // 没有全部中奖记录，清空数组
              this.winnerList = [];
            }
          } else {
            Dialog.alert({
              message: res.message || "获取全部中奖记录失败"
            });
          }
        },
        failure: err => {
          this.refreshInterfaceCount++;
          Dialog.alert({
            message: err.message || "获取全部中奖记录失败"
          });
        }
      });
    },
    // 查询中奖记录，包括我的中奖记录，全部中奖记录
    getRecord(currentAwardRefresh = false) {
      this.getUserRewardRecords(currentAwardRefresh);
      this.getAllRewardRecords();
    },
    // 查看我的中奖记录
    viewRecord(item) {
      this.isFilledFlag = false;
      if (
        item.rewardType === BWC.GoodsType.virtualAward &&
        item.collectionType === BWC.CollectionType.expressOrOnlineCheckOff
      ) {
        // 虚拟权益品-线上兑换，奖品已过期 且 用户未获取卡密
        if (
          this.isOutDateList[item.bigwheelRewardRecodeId] &&
          !item.rewardRecordextendConfigPrivacy
        ) {
          Toast("超过领取时间，无法兑换");
          return;
        }
      } else if (
        item.rewardType === BWC.GoodsType.entityAward &&
        item.collectionType === BWC.CollectionType.expressOrOnlineCheckOff
      ) {
        // 实物权益品-线上邮寄，奖品已过期 且 用户未填写信息
        if (
          this.isOutDateList[item.bigwheelRewardRecodeId] &&
          !item.extendConfigFlag
        ) {
          Toast("超过领取时间，无法兑换");
          return;
        }
      } else {
        if (this.isOutDateList[item.bigwheelRewardRecodeId]) {
          Toast("超过领取时间，无法兑换");
          return;
        }
      }
      this.winRewardGoods.appointmentFlag = item.appointmentFlag;
      this.awardObj = {};
      let extendConfig = JSON.parse(item.extendConfig) || {};
      if (
        item.extendConfigFlag &&
        item.rewardType == BWC.GoodsType.entityAward
      ) {
        extendConfig = JSON.parse(item.extendConfig);
        extendConfig.userName = item.rewardRecordextendConfigPrivacy.userName;
        extendConfig.userPhone = item.rewardRecordextendConfigPrivacy.userPhone;
        extendConfig.userAddress =
          item.rewardRecordextendConfigPrivacy.userAddress;
      }
      this.awardObj = Object.assign(extendConfig, item);
      if (this.awardObj.collectionType !== "4") {
        this.awardObj.drawOrderSource = null;
      }
      // 抽奖后展示下一级 || 抽奖机会为0展示下一级
      if (
        (this.hasNextActivityFlag && this.jumpNextPageType === "0") ||
        (this.hasNextActivityFlag && this.jumpNextPageType === "1")
      ) {
        this.awardObj.singleFlag = true;
      }
      this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
      if (item.rewardType === BWC.GoodsType.virtualAward) {
        //虚拟
        // 免单流程
        // drawOrderSource 0:无;1:PC;2:APP;3:微信HI荣耀小程序;4:支付宝HI荣耀小程序
        if (item.drawOrderSource === "1" || item.drawOrderSource === "2") {
          item.isBeneficial = true;
        }
        // 线下核销2、线下核销发卡密3，免单抽奖4
        if (
          [
            BWC.CollectionType.inStore,
            BWC.CollectionType.checkOffStrCode,
            BWC.CollectionType.freeOfCharge
          ].includes(item.collectionType)
        ) {
          //跳转预约导购
          this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
            flag: true,
            codeId: this.awardObj.exchangeActivationCodeId,
            type: item.collectionType,
            ...this.awardObj
          }); //跳转hi荣耀预约创建不需要录入客户信息
        } else {
          //正常不跳转的
          // 如果有客户信息直接展示虚拟奖品弹框
          if (item.rewardRecordextendConfigPrivacy) {
            this.$refs.resultDialog.$refs.virtualAwardModal.openModel();
          } else {
            this.userInfoList = item.userInfoList || [];
            //没有展示虚拟客户需要录入信息的弹框
            this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel();
          }
        }
      } else if (item.rewardType === BWC.GoodsType.entityAward) {
        //实物
        // 领取方式为（2：到店自提）或（5：货柜自取）
        if (
          [
            BWC.CollectionType.inStore,
            BWC.CollectionType.containerPickup
          ].includes(item.collectionType)
        ) {
          // 并且预约导购为否0 并且是否收集消费者信息为是，需要根据配置显示弹出填写消费者信息
          if (
            item.appointmentFlag === BWC.appointmentFlag.noNeed &&
            item.userInfoList &&
            item.userInfoList.length > 0
          ) {
            if (item.rewardRecordextendConfigPrivacy) {
              // 查看中奖记录，如果已填写消费者信息，直接回显展示
              this.userInfoList =
                item.rewardRecordextendConfigPrivacy.userInfoList || [];
              this.isFilledFlag = true;
            } else {
              // 查看中奖记录，如果未填写消费者信息，根据配置展示去填写
              this.userInfoList = item.userInfoList || [];
            }
            this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel();
          } else {
            this.$refs.resultDialog.$refs.receiveAwardModal.openModel({
              flag: this.isGuideFlag,
              codeId: this.awardObj.exchangeActivationCodeId,
              type: item.collectionType,
              ...this.awardObj,
              // 打开弹窗方式，drawHandler：抽奖结果处理，viewRecord：查看我的中奖记录
              openSrc: "viewRecord"
            }); //跳转hi荣耀预约创建不需要录入客户信息
          }
        } else {
          this.$refs.resultDialog.$refs.kindAwardModal.openModel();
        }
      } else if (
        [BWC.GoodsType.coupon, BWC.GoodsType.voucher].includes(item.rewardType)
      ) {
        //优惠券、代金券
        if (item.goodsPictureUrl) {
          const pic = JSON.parse(item.goodsPictureUrl);
          const imgItem = this.$utils.getImageUrl(pic.file);
          this.awardObj.imgItem = imgItem;
        }
        if (item.voucherStartDate && item.voucherEndDate) {
          this.awardObj.voucherStartDate = item.voucherStartDate;
          this.awardObj.voucherEndDate = item.voucherEndDate;
        }
        console.log("------------this.awardObj---------", this.awardObj);
        this.$refs.resultDialog.$refs.couponModal.openModel();
      } else if (item.rewardType === BWC.GoodsType.giftCoupon) {
        // 赠品券
        this.awardObj.collectionType = "2";
        this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
          flag: true,
          codeId: this.awardObj.exchangeActivationCodeId,
          type: item.collectionType,
          ...this.awardObj
        });
      }
    },
    //实物奖品录入完客户信息再打开实物奖品弹框
    openKindAwardModal() {
      this.$refs.resultDialog.$refs.kindAwardModal.openModel();
    },
    //虚拟奖品录入完客户信息再打开虚拟奖品弹框
    openVirtualAwardModal() {
      this.$refs.resultDialog.$refs.virtualAwardModal.openModel();
    },
    // 配置的为实物+到店自提+无预约导购+有收集消费者信息，填写或消费者信息之后再打开实物奖品弹框
    openReceiveAwardModal(val) {
      this.awardObj.writeOffCodeUrl = val ? val : this.awardObj.writeOffCodeUrl;
      this.$refs.resultDialog.$refs.receiveAwardModal.openModel({
        flag: false
      });
    },
    openAwardModalFromEndPage(obj) {
      this.awardObj = Object.assign({}, obj);
      this.$refs.resultDialog.$refs.receiveAwardModal.openModel({
        flag: false
      });
    },
    //判断大转盘活动是否有对应门店
    checkLottyChannel(activityCode, channelCode) {
      return new Promise(resolve => {
        const params = {
          activityCode: activityCode,
          channelCode: channelCode || sessionStorage.getItem("navChannelCode")
        };
        this.$api.post({
          noLoading: true,
          sc: "mobileMarketingH5",
          url: "ArrangementActivity/checkBigWheelActivityByChannelCode",
          params,
          success: r => {
            this.refreshInterfaceCount++;
            resolve(r);
          },
          failure: err => {
            this.refreshInterfaceCount++;
          }
        });
      });
    },
    //判断大转盘是否有抽奖次数
    checkLottyTimes() {
      const self = this;
      return new Promise(resolve => {
        const params = {
          userOpenid:
            self.loginType == BWC.LoginType.Wechat
              ? self.userBase.openId || ""
              : "",
          userUnionid:
            self.loginType == BWC.LoginType.Wechat
              ? self.userBase.unionid || ""
              : "",
          alipayUserId:
            self.loginType == BWC.LoginType.Alipay
              ? sessionStorage.getItem("alipayUserId") || ""
              : "",
          loginType: self.loginType || "",
          associationActivityCode: sessionStorage.getItem(
            "associationActivityCode"
          )
        };
        this.$api.post({
          noLoading: true,
          sc: "mobileMarketingH5",
          url: "ArrangementActivity/checkBigWheelActivityByTimes",
          params,
          success: r => {
            self.refreshInterfaceCount++;
            resolve(r);
          },
          failure: err => {
            self.refreshInterfaceCount++;
          }
        });
      });
    },
    // 抽奖事件
    async pointer(boxIndex) {
      if (
        this.loginType !== "none" &&
        this.isLoginFlag &&
        [
          USER_LIMIT_STATUS.QY_WECHAT_GUIDE_TIME_LIMIT,
          USER_LIMIT_STATUS.COMMUNITY_USER_TIME_LIMIT,
          USER_LIMIT_STATUS.JOIN_MEMBER_TIME_LIMIT,
          USER_LIMIT_STATUS.NOT_ADD_QY_WECHA_GUIDE_LIMIT,
          USER_LIMIT_STATUS.NOT_ADD_COMMUNITY_LIMIT
        ].includes(this.userLimitStatus) &&
        this.activityStatus === BWC.ActivityStatus.running
      ) {
        // 抽奖对象首先是会员，而且要登录状态，userLimitStatus为用户身份限制状态
        userLimitHandler(
          this.userLimitStatus,
          ActivityType.bigTurnable,
          this.activityObj.activityConfig,
          "parent",
          this
        );
        return;
      }

      if (
        !this.isLoginFlag &&
        (this.loginType === "wechat" || this.loginType === "Alipay")
      ) {
        noLoginHandler(this.loginType, this.activityUrl);
        return;
      }
      // 1表示接口开启跳转其他活动，有活动链接的返回，
      this.showOtherActivity =
        this.customerIdentityNextUrlConfig === ShowOtherActivity.display;
      // 当接口返回活动是新用户或者老用户时
      if (
        this.restrictType === CustomerGroup.newOldUser &&
        (this.customerIdentity === IdentityVerify.newUser ||
          this.customerIdentity === IdentityVerify.oldUser)
      ) {
        // 表示当前活动身份是老用户或者新用户，要进行身份验证
        if (this.customerIdentity === this.mobileVerification) {
          // 当前用户身份（新老）与配置相符
          this.isShowIdentityDialog = false;
        } else {
          // 当前用户身份（新老）与配置不符
          if (this.miniprogramFlag) {
            // 在小程序环境打开（小程序可以获取到设备信息判断新老用户）
            this.raffleVerifyTitle =
              this.customerIdentity === IdentityVerify.newUser
                ? "您是老用户无法参与当前活动"
                : "您是新用户无法参与当前活动";
            this.isShowIdentityDialog = true;
          }
          return;
        }
      } else {
        this.isShowIdentityDialog = false;
      }
      Toast.loading({
        message: "加载中...",
        forbidClick: true
      });
      const self = this;
      // 活动被引用且存在联合活动编码时（活动编排场景）
      if (
        this.activityObj.isUsed === BWC.isUsed.yes &&
        sessionStorage.getItem("associationActivityCode")
      ) {
        const res = await this.checkLottyTimes();
        if (!res.result) {
          Dialog.alert({
            title: "提示",
            message: "您已达到本次抽奖活动的最大抽奖次数,感谢您的支持！"
          }).then(() => {
            if (self.hasNextActivityFlag) {
              self.nextStep();
            }
          });
          return;
        }
      }
      // 定时开奖盲盒活动 并且微信登陆、在小程序环境里打开、用户首次抽奖，则跳转小程序页面拉起订阅通知
      // （可抽取为一个方法）
      if (
        this.drawWheelType === BWC.DrawWheelType.timedDraw &&
        [
          BWC.BigWheelActivityType.blindBox,
          BWC.BigWheelActivityType.newBlindBox
        ].includes(this.bigWheelActivityType) &&
        this.miniprogramFlag &&
        this.loginType === BWC.LoginType.Wechat &&
        !this.whetherActivity
      ) {
        console.log("准备跳转拉起微信订阅授权===>");
        const res = await this.queryNeedNotityInfo();
        let needNotifyRewardsInfo = res.result;
        needNotifyRewardsInfo = JSON.stringify(needNotifyRewardsInfo);
        wx.miniProgram.navigateTo({
          url: `/subpackages/activity/pages/activityH5Notify/activity-h5-notify?bigWheelActivityType=${
            this.bigWheelActivityType
          }&needNotifyRewardsInfo=${encodeURIComponent(needNotifyRewardsInfo)}`
        });
      }
      // 大转盘正在旋转，直接返回，不能进行抽奖
      if (
        this.turnplate.bRotate &&
        this.bigWheelActivityType === BWC.BigWheelActivityType.bigTurnable
      ) {
        return;
      }
      // 如果是多门店共用一条活动链接，则要有门店编码才能进行抽奖
      if (this.isMultiStoreInOneLink) {
        if (!this.channelCode) {
          Toast("请选择门店再参与活动");
          return;
        }
      }
      // 抽奖中标识设置
      this.turnplate.bRotate = !this.turnplate.bRotate;
      if (this.bigWheelActivityType === BWC.BigWheelActivityType.bigTurnable) {
        //让转盘先转起来
        $("#wheelcanvas").rotate({
          angle: 0,
          animateTo: 5400,
          duration: 15000
        });
      }
      // 用户性别
      let userGender = "";
      if (self.userBase.sex === 1 || self.userBase.gender === "m") {
        userGender = "1";
      } else if (self.userBase.sex === 2 || self.userBase.gender === "f") {
        userGender = "2";
      }
      // 头像
      const headimgurl = self.userBase.headimgurl;
      // 抽奖接口入参
      const params = {
        activityCode: self.drawCode || self.activityObj.activityCode,
        openId:
          self.loginType === BWC.LoginType.Wechat
            ? self.userBase.openId || ""
            : "",
        unionid:
          self.loginType === BWC.LoginType.Wechat
            ? self.userBase.unionid || ""
            : "",
        alipayUserId:
          self.loginType === BWC.LoginType.Alipay
            ? sessionStorage.getItem("alipayUserId") || ""
            : "",
        loginType: self.loginType || "",
        loginSide:
          self.loginType === BWC.LoginType.Wechat
            ? "wxapp"
            : self.loginType === BWC.LoginType.Alipay
            ? "alipaymini"
            : "",
        drawType: self.drawType,
        referrFlag: self.userBase.referrFlag ? self.userBase.referrFlag : 0,
        nickName: self.userBase.nickName || self.userBase.accountNo || "",
        sex: userGender,
        headimgurl: headimgurl,
        channelCode: this.isMultiStoreInOneLink ? this.channelCode : "",
        userRewardRegion: this.adminRegions
      };
      params.memberCode = this.memberInfo.memberCenterId;
      // nickName设置为隐私结构体了，支付宝和微信都一样
      const privacyKeys = {
        nickName: "$PrivacyPlain$"
      };
      //隐私信息保存
      const privacyKeyLsit = [
        {
          nickName: "nickName",
          typeText: "NAME",
          labelText: "nick_name"
        }
      ];
      self.$utils.privacySave(privacyKeys, privacyKeyLsit, params);
      if (
        !self.drawCode &&
        this.activityObj.isUsed === BWC.isUsed.yes &&
        this.activityObj.channelFlag === "2" &&
        sessionStorage.getItem("associationActivityCode") &&
        sessionStorage.getItem("navChannelCode") &&
        self.activityObj.activityUrlTypel === "1"
      ) {
        params.activityCode = `${
          self.activityObj.activityCode
        }_${sessionStorage.getItem("navChannelCode")}`;
      }
      // 抽奖前置处理
      const beforeDrawHandlerRes = await this.beforeDrawHandler();
      console.log("beforeDrawHandlerRes", beforeDrawHandlerRes);
      if (beforeDrawHandlerRes !== true) {
        // 接口返回失败，则弹窗提示错误，且不再进行抽奖
        Dialog.alert({
          message: beforeDrawHandlerRes
        });
        return;
      } else {
        params.regionalId = this.regionalId;
        params.provincesRegionalId = this.provincesRegionalId;
      }
      // 进行抽奖，并查询接口
      self.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: "h5/bigWheel/getWinRewardGoods",
        params: params,
        success: r => {
          Toast.clear();
          // 抽奖动作埋码，根据不同活动上报
          this.handleDrawProcess(this.bigWheelActivityType);
          if (r.code === 500) {
            this.activityStatus = BWC.ActivityStatus.paused;
            Dialog.alert({
              title: "提示",
              message: r.message
            });
          }
          // 埋码事件：抽奖结果
          if (r && r.result && r.result.bigWheelRewards) {
            this.handleClickResultAwardRotateProcess(r.result.bigWheelRewards);
          }
          if (
            this.bigWheelActivityType === BWC.BigWheelActivityType.newBlindBox
          ) {
            // 新盲盒-定时抽奖
            if (this.drawWheelType === BWC.DrawWheelType.timedDraw) {
              this.getLotty();
            } else {
              // 新盲盒-普通抽奖
              if (r && r.result && r.result.bigWheelRewards) {
                this.currentAward = r.result.bigWheelRewards;
              } else {
                this.currentAward = {};
              }
              this.getChance();
              this.getRecord(true);
              return;
            }
          }
          if (r && r.result) {
            const result = r.result.bigWheelRewards;
            this.userInfoList = r.result.userInfoList || [];
            this.winRewardGoods = r.result;
            this.activityStatus = r.result.activityStatus;
            // otherDraw => 额外抽奖次数，true：当前额外抽奖次数为0
            if (r.result.otherDraw) {
              if (this.userBase.member) {
                self.getChance();
              } else {
                this.pointDrawFlag = true;
              }
              if (
                this.bigWheelActivityType ===
                BWC.BigWheelActivityType.bigTurnable
              ) {
                $("#wheelcanvas").stopRotate();
              }
              self.$utils.tips.message("warning", r.result.message);
              return;
            }
            // 抽奖结果信息返回不为空，说明抽奖成功
            if (result) {
              if (this.tigerLottery) {
                // 老虎机开始抽奖
                this.$refs.rouletteKoi.$refs.tigerMachineDraw.drawLottery();
              }
              //不需要核销跳预约导购页面的collectionType得手动赋值1
              //虚拟||实物 && 如果id没值（代表正常的 1:邮寄(实物)/线上兑换(虚拟))
              if ([1, 2].includes(result.goodsType) && !result.id) {
                result.collectionType = 1;
              }
              // 如果为盲盒抽奖
              if (
                this.bigWheelActivityType === BWC.BigWheelActivityType.blindBox
              ) {
                this.boxIndex = boxIndex;
                setTimeout(() => {
                  this.boxIndex = "";
                  this.rotateFn(result);
                  if (this.userBase.member) {
                    this.getChance();
                  } else {
                    this.pointDrawFlag = true;
                  }
                }, 500);
              } else if (
                this.bigWheelActivityType ===
                BWC.BigWheelActivityType.newBlindBox
              ) {
                this.showEndPage = true;
                this.getChance();
              } else {
                // 大转盘抽奖
                this.rotateFn(result);
                if (this.userBase.member) {
                  this.getChance();
                } else {
                  this.pointDrawFlag = true;
                }
              }
            } else {
              // 抽奖失败
              if (this.activityStatus === BWC.ActivityStatus.finished) {
                this.$utils.tips.message("warning", "当前活动已结束！");
              } else if (
                this.activityStatus === BWC.ActivityStatus.running &&
                !r.result.flag
              ) {
                // 活动进行中 用户不可以抽奖
                this.canDrawFlag = false;
                this.participateTimes = 0;
                this.noChance();
              } else if (this.activityStatus === BWC.ActivityStatus.paused) {
                this.hasStop();
              }
            }
          }
        },
        failure: err => {
          Toast.clear();
          if (
            this.bigWheelActivityType === BWC.BigWheelActivityType.bigTurnable
          ) {
            $("#wheelcanvas").stopRotate();
          }
          Dialog.alert({
            title: "提示",
            message: "活动过于火爆，请稍后再试"
          });
          self.turnplate.bRotate = !self.turnplate.bRotate;
        }
      });
    },
    // 身份验证之后，无法参加当前活动，去点击参加其他活动事件
    goOtherActivity() {
      this.nextStep(this.customerIdentityNextUrl, BWC.JumpType.customLink);
    },
    queryNeedNotityInfo() {
      return new Promise(resolve => {
        let params = [];
        params = this.bigWheelRewardList.map(item => ({
          goodsType: item.goodsType, //0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
          collectionType: item.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
          businessId: item.activityCode, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
          businessType: "9", //业务类型 12.签到  7.专题活动 9.大转盘
          goodsId: item.goodsId,
          bigWheelActivityType: this.bigWheelActivityType, // 抽奖类型 bigWheelActivityType 1 => 大转盘   2 => 盲盒  3 => 轮盘锦鲤   4 => 新盲盒
          drawWheelType: this.drawWheelType //大转盘抽奖类型 drawWheelType  1 => 普通抽奖   2 => 整点购抽奖   3 => 定时开奖
        }));
        this.$api.post({
          sc: "mobileMarketing",
          url: "miniActivityController/getUserWxSubscribeMsgTemplateId",
          params: params,
          success: r => {
            resolve(r);
          }
        });
      });
    },
    rotateFn(obj) {
      const self = this;
      let index = 0;
      let exitFlag = false;
      const bigWheelRewardList = self.bigWheelRewardList;
      const len = bigWheelRewardList.length;
      for (let i = 0; i < len; i++) {
        // 根据奖品ID与奖品池ID进行对比
        if (obj.id === bigWheelRewardList[i].id) {
          index = i;
          exitFlag = true;
          break;
        }
      }
      // 当前中奖物品未能匹配到奖品池物品
      if (!exitFlag) {
        self.$utils.tips.message(
          "warning",
          "奖项配置发生变化，请刷新页面后重试！"
        );
        return false;
      }
      if (this.tigerLottery) {
        // 老虎机抽奖结果展示
        this.$refs.rouletteKoi.$refs.tigerMachineDraw.displayDrawResult(
          index,
          obj
        );
        return;
      }
      // 大转盘停留位置控制
      const item = index + 1;
      let angles =
        item * (360 / this.turnplate.restaraunts.length) -
        360 / (this.turnplate.restaraunts.length * 2);
      if (angles < 270) {
        angles = 270 - angles;
      } else {
        angles = 360 - angles + 270;
      }
      this.$nextTick(() => {
        if (this.bigWheelActivityType == BWC.BigWheelActivityType.bigTurnable) {
          $("#wheelcanvas").stopRotate();
          $("#wheelcanvas").rotate({
            angle: 0,
            animateTo: angles + 1800,
            duration: 5000,
            callback: function() {
              self.handleAwardWinning(obj, index);
            }
          });
        } else if (
          this.bigWheelActivityType === BWC.BigWheelActivityType.blindBox
        ) {
          self.handleAwardWinning(obj, index);
        }
      });
    },
    // 老虎机中奖结果处理
    tigerMachineWinningHandler(param) {
      this.handleAwardWinning(param.awardObj, param.awardIndex);
    },
    // 中奖处理
    handleAwardWinning(obj, index) {
      // goodsType ,0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
      // collectionType 领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟)) 4:免单抽奖
      //跳转预约导购：（实物||虚拟）&& （2 || 3）
      this.isFilledFlag = false;
      //未中奖
      this.awardObj = this.bigWheelRewardList[index];
      this.awardObj.bigWheelActivityType = Number(this.bigWheelActivityType);
      this.awardObj.effectiveStartTime = this.winRewardGoods.effectiveStartTime;
      this.awardObj.effectiveEndTime = this.winRewardGoods.effectiveEndTime;
      this.awardObj.appointmentFlag = this.winRewardGoods.appointmentFlag;
      // 实物奖品，货柜自提领取方式涉及字段
      this.awardObj.rewardType = this.winRewardGoods.bigWheelRewards.goodsType;
      this.awardObj.pickUpCode = this.winRewardGoods.bigWheelRewards.pickUpCode;
      this.awardObj.inventoryFlag = this.winRewardGoods.inventoryFlag;
      this.awardObj.userQrCode = this.winRewardGoods.userQrCode;
      this.awardObj.channelName = this.winRewardGoods.channelName;
      this.awardObj.jumpType = this.winRewardGoods.bigWheelRewards.jumpType;
      this.awardObj.jumpUrl = this.winRewardGoods.bigWheelRewards.jumpUrl;
      this.awardObj.activityStatus = this.winRewardGoods.activityStatus;
      if (this.awardObj.collectionType !== BWC.CollectionType.freeOfCharge) {
        this.awardObj.drawOrderSource = null;
      }
      // 未中奖
      if (obj.goodsType && obj.goodsType === BWC.GoodsType.noAward) {
        if (
          !this.regularDrawShowStatus ||
          (this.regularDrawShowStatus &&
            (this.regularDrawShowStatus == "1" ||
              this.regularDrawShowStatus == "2"))
        ) {
          this.$refs.resultDialog.$refs.noAwardModal.openModel();
        } else {
          this.getLotty();
        }
      }
      // 虚拟中奖
      else if (obj.goodsType && obj.goodsType === BWC.GoodsType.virtualAward) {
        // 虚拟奖品：线下核销2、线下核销发卡密3，免单抽奖4
        if (
          [
            BWC.CollectionType.inStore,
            BWC.CollectionType.checkOffStrCode,
            BWC.CollectionType.freeOfCharge
          ].includes(obj.collectionType)
        ) {
          //虚拟
          //小程序类型 1 => 体验店  2 => 直营店
          this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
            flag: true,
            codeId: obj.activationCodeId,
            type: obj.collectionType,
            businessType: "9", //12.签到  7.专题活动 9.大转盘
            ...this.awardObj,
            ...obj
          });
        } else {
          this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
            flag: false
          });
        }
      }
      // 实物中奖
      else if (obj.goodsType && obj.goodsType === BWC.GoodsType.entityAward) {
        //实物-到店自提2，货柜自取5
        if (
          [
            BWC.CollectionType.inStore,
            BWC.CollectionType.containerPickup
          ].includes(obj.collectionType)
        ) {
          if (
            obj.appointmentFlag === BWC.appointmentFlag.noNeed &&
            this.userInfoList &&
            this.userInfoList.length > 0
          ) {
            this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel();
          } else {
            this.$refs.resultDialog.$refs.receiveAwardModal.openModel({
              flag: this.isGuideFlag,
              codeId: obj.activationCodeId,
              type: obj.collectionType,
              // 打开弹窗方式，drawHandler：抽奖结果处理，viewRecord：查看我的中奖记录
              openSrc: "drawHandler"
            }); //跳转hi荣耀预约创建不需要录入客户信息
          }
        } else {
          if (
            obj.collectionType === BWC.CollectionType.expressOrOnlineCheckOff
          ) {
            // 奖品为实物奖品-线上邮寄时，中奖领取奖品后打开用户录入信息弹窗
            // 此时：1、用户未填写信息，2、权益品未过期（按未过期填写表单，最后提交表单时后端接口会校验是否过期），3、奖品未锁定（奖品锁定的前提是用户已填写信息）
            this.awardObj.extendConfigFlag = false;
            this.awardObj.goodsOverdueFlag = false;
            this.awardObj.hasLockedFlag = false;
          }
          this.$refs.resultDialog.$refs.receiveAwardModal.openModel({
            flag: false
          });
        }
      }
      // 优惠券中奖3、代金券中奖5
      else if (
        obj.goodsType &&
        [BWC.GoodsType.coupon, BWC.GoodsType.voucher].includes(obj.goodsType)
      ) {
        console.log("33333333333");
        console.log("------------this.awardObj---------", this.awardObj);
        if (obj.goodsType == "5") {
          //代金券中奖涉及字段 代金券生效时间、跳转活动
          this.awardObj.voucherStartDate = this.winRewardGoods.bigWheelRewards.voucherStartDate;
          this.awardObj.voucherEndDate = this.winRewardGoods.bigWheelRewards.voucherEndDate;
        }
        this.$refs.resultDialog.$refs.couponModal.openModel({
          businessType: "9", //12.签到  7.专题活动 9.大转盘 18.邀请到店有礼
          ...this.awardObj,
          ...obj
        });
      }
      // 积分中奖4
      else if (
        obj.goodsType &&
        obj.goodsType === BWC.GoodsType.accumulatePoints
      ) {
        this.$refs.resultDialog.$refs.pointModal.openModel();
      }
      // 赠品券中奖6
      else if (obj.goodsType && obj.goodsType === BWC.GoodsType.giftCoupon) {
        this.awardObj.collectionType = "2";
        this.$refs.resultDialog.$refs.virtualizedAwardModal.openModel({
          flag: true,
          codeId: obj.activationCodeId,
          type: obj.collectionType,
          businessType: "9", //12.签到  7.专题活动 9.大转盘
          ...this.awardObj,
          ...obj
        });
      }
      this.getRecord();
      this.awardObj = this.bigWheelRewardList[index];
      this.awardObj.recordId = obj.recordId;
      this.awardObj.activationCode = obj.activationCode;
      if (
        obj.goodsType &&
        [BWC.GoodsType.coupon, BWC.GoodsType.voucher].includes(obj.goodsType)
      ) {
        const pic = JSON.parse(obj.goodsPictureUrl);
        const imgItem = this.$utils.getImageUrl(pic.file);
        this.awardObj.imgItem = imgItem;
      }
      if (
        (this.hasNextActivityFlag && this.jumpNextPageType === "0") ||
        (!this.participateTimes &&
          this.hasNextActivityFlag &&
          this.jumpNextPageType === "1")
      ) {
        this.awardObj.singleFlag = true;
      }
      this.turnplate.bRotate = !this.turnplate.bRotate;
    },
    // 定时抽奖 增加抽奖按钮 点击去抽奖
    goLottery() {
      if (
        !this.isLoginFlag &&
        (this.loginType === "wechat" || this.loginType === "Alipay")
      ) {
        noLoginHandler(this.loginType, this.activityUrl);
        return;
      }
      console.log("goLottery里的this.canDrawFlag", this.canDrawFlag);
      if (
        this.canDrawFlag &&
        this.activityStatus == BWC.ActivityStatus.running
      ) {
        this.pointer("");
      } else {
        if (this.activityStatus == BWC.ActivityStatus.finished) {
          // 活动结束提示
          this.hasEnd();
          return;
        }
        this.noChance();
      }
    },

    /**
     * @param {string} link 跳转地址
     * @param {string} type 跳转方式('0'-小程序代金券列表,不涉及代金券、'1'-小程序首页、'2'-自定义链接、'3'-入会好礼奖品默认页面、'4'-笑傲程序优惠券列表、'9'-无跳转)
     */
    nextStep(link, type) {
      // 小程序 WebView 中配置第三方 miniAppId 时，通过 Hi 荣耀小程序中转页跳转
      // miniAppId 按中奖数据所在位置取值，三者对应不同中奖弹窗场景：
      //  awardObj：大转盘/盲盒/轮盘锦鲤，中奖后由 handleAwardWinning 从奖品池赋值
      //  currentAward：新盲盒普通抽奖/整点购抽奖，中奖后由抽奖接口返回赋值
      //  myRecord[0]：新盲盒定时开奖/整点购抽奖，即 end-page 展示的 awardObj
      const miniAppId =
        this.awardObj.miniAppId ||
        this.currentAward.miniAppId ||
        (this.myRecord[0] && this.myRecord[0].miniAppId);
      if (
        miniAppId &&
        this.loginType === BWC.LoginType.Wechat &&
        this.miniprogramFlag
      ) {
        const path = link || "";
        wx.miniProgram.navigateTo({
          url: `/subpackages/activity/pages/transferPage/transferPage?appId=${encodeURIComponent(
            miniAppId
          )}&path=${encodeURIComponent(path)}`
        });
        return;
      }
      if (type === "1") {
        if (this.miniprogramFlag) {
          // 微信
          if (this.loginType === BWC.LoginType.Wechat) {
            wx.miniProgram.switchTab({
              url: "/pages/tabBar/index/index",
              success: function() {
                console.log("跳转回小程序的页面success");
              },
              fail: function(res) {
                console.log("跳转回小程序的页面fail", res);
              }
            });
            // 支付宝
          } else {
            my.switchTab({
              url: "/pages/tabBar/index/index"
            });
          }
        } else {
          //在支付宝内部浏览器打开
          window.location.href =
            "alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index";
        }
      }
      if (link && type === "2") {
        // 跳转积分商城判断
        if (pointsMallLinkJudge(link) !== PMLinkType.notMatch) {
          jumpToPointsMall(this.activityCode, link);
          return;
        }
        // 链接包含HTTP，且没有webViewSrc字段
        if (link.indexOf("http") > -1 && link.indexOf("webViewSrc") === -1) {
          // H5链接(可能是活动、第三方链接)
          if (link.indexOf("hdmain") > -1) {
            // 上报父级页面
            // 父级页面信息
            console.log("跳转hd活动=====》", link.split("?")[1]);
            const path =
              "/hdmain?" +
              link.split("?")[1] +
              "&parentPage=bigTurntable&parentActivityCode=" +
              this.activityCode;
            console.log(path);
            this.$router.push({
              path: path
            });
            this.$store.commit("base/setIsRouterAlive", false);
            this.$nextTick(() =>
              this.$store.commit("base/setIsRouterAlive", true)
            );
          } else {
            console.log("其他链接=====》");
            window.location.href = link;
          }
        } else if (
          link.indexOf("http") == -1 &&
          link.indexOf("https") == -1 &&
          link.indexOf("HD") > -1
        ) {
          // 链接为活动编码， 例:HD1687663056563
          const path =
            "/hdmain?activityCode=" +
            link +
            "&parentPage=bigTurntable&parentActivityCode=" +
            this.activityCode;
          this.$router.push({
            path: path
          });
          this.$store.commit("base/setIsRouterAlive", false);
          this.$nextTick(() =>
            this.$store.commit("base/setIsRouterAlive", true)
          );
        } else {
          // 链接为小程序链接 (小程序页面、活动)
          let usePath = link;
          if (link.indexOf("webViewSrc") > -1) {
            const goUrl = encodeURIComponent(
              link +
                "&parentPage=bigTurntable&parentActivityCode=" +
                this.activityCode
            );
            usePath = `/pages/webView/activity-web-view?webViewSrc=${goUrl}`;
          }
          if (this.miniprogramFlag) {
            if (this.loginType === BWC.LoginType.Wechat) {
              //在微信小程序内部打开
              link.startsWith("/pages/tabBar") &&
                wx.miniProgram.switchTab({
                  url: link
                });
              !link.startsWith("/pages/tabBar") &&
                wx.miniProgram.navigateTo({
                  url: usePath,
                  success: function() {
                    console.log("跳转回小程序的页面success");
                  },
                  fail: function(res) {
                    console.log("跳转回小程序的页面fail", res);
                  }
                });
            } else {
              // 在支付宝小程序内部打开
              link.startsWith("/pages/tabBar") &&
                my.switchTab({
                  url: link
                });
              !link.startsWith("/pages/tabBar") &&
                my.redirectTo({
                  url: usePath,
                  success: function() {
                    console.log("跳转回小程序的页面success");
                  },
                  fail: function(res) {
                    console.log("跳转回小程序的页面fail", res);
                  }
                });
            }
          } else {
            // 小程序活动页面——支付宝H5场景
            if (link.indexOf("webViewSrc") > -1) {
              let usePath = link;
              const goUrl = encodeURIComponent(
                link +
                  "&parentPage=bigTurntable&parentActivityCode=" +
                  this.activityCode
              );
              usePath = `pages/webView/activity-web-view?webViewSrc=${goUrl}`;
              const url = `alipays://platformapi/startapp?appId=2021002121684220&page=${usePath}`;
              window.location.href = url;
              // H5页面
            } else {
              const linkArr = link.split("?");
              let href = "";
              if (linkArr.length > 1) {
                if (
                  linkArr[1].includes("skuCode") ||
                  linkArr[1].includes("spuCode")
                ) {
                  if (linkArr[0].includes("product-details-global")) {
                    href = `alipays://platformapi/startapp?appId=2021002121684220&page=${
                      linkArr[0]
                    }&query=${encodeURIComponent(linkArr[1])}`;
                  } else {
                    href = `alipays://platformapi/startapp?appId=2021002121684220&page=${
                      linkArr[0]
                    }?${encodeURIComponent(linkArr[1])}`;
                  }
                } else {
                  href = `alipays://platformapi/startapp?appId=2021002121684220&page=${
                    linkArr[0]
                  }?${encodeURIComponent(linkArr[1])}`;
                }
                window.location.href = href;
              } else {
                href = `alipays://platformapi/startapp?appId=2021002121684220&page=${link}`;
              }
              window.location.href = href;
            }
          }
        }
      }
      if (type === "4") {
        if (this.miniprogramFlag) {
          if (this.loginType === BWC.LoginType.Wechat) {
            wx.miniProgram.navigateTo({
              url: `/subpackages/my/pages/couponList/coupon-list?couponType=0`,
              success: function() {
                console.log("跳转回小程序的页面success");
              },
              fail: function(res) {
                console.log("跳转回小程序的页面fail", res);
              }
            });
          } else if (this.loginType === BWC.LoginType.Alipay) {
            my.redirectTo({
              url: "/subpackages/my/pages/couponList/coupon-list?couponType=0"
            });
          }
        } else {
          window.location.href =
            "alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/couponList/coupon-list";
        }
      }
      if (type === "0") {
        if (this.loginType === BWC.LoginType.Wechat) {
          wx.miniProgram.navigateTo({
            url: `/subpackages/my/pages/couponList/coupon-list?couponType=1`,
            success: function() {
              console.log("跳转回小程序的页面success");
            },
            fail: function(res) {
              console.log("跳转回小程序的页面fail", res);
            }
          });
        }
      }
    },
    /**
     * 实物+线上邮寄：填写用户信息之后，需要刷新我的中奖记录
     */
    refreshMyRecords() {
      this.getRecord();
    },
    /**
     * @param {object} data 传参
     * @param {string} data.helpingRedirectConfig 跳转配置('0'-否、'1'-是)
     * @param {string} data.helpingRedirectMode 跳转方式('1'-指定页面、'2'-自定义链接)
     * @param {string} data.helpingRedirectType 跳转类型('1'-直播、'2'-商详页、'3'-活力魔方页、'4'-我的积分、'5'-我的-优惠券、'6'-我的-代金券、'7'-小程序首页)
     * @param {string} data.helpingRedirectConfigContent 跳转配置内容('1'-指定页面(1、直播:房间号;2、商详页:商品编码;3、活力魔方页:活动编码;4,5,6:为空)、'2'-自定义链接)
     */
    goSkipPage(data) {
      if (data.helpingRedirectConfig === "0") return;
      // 指定页面
      if (data.helpingRedirectMode === "1") {
        /**
         * @param {string} URL_MINIPROGRAM 小程序跳转地址
         */
        let URL_MINIPROGRAM = "";
        /**
         * @param {string} URL_ALIPAY 支付宝H5跳转地址
         */
        let URL_ALIPAY = "";
        let userInfo = sessionStorage.getItem("userInfo");
        if (userInfo) {
          userInfo = JSON.parse(userInfo);
        }
        let queryTwo = "";
        const query = encodeURIComponent(
          `memberCenterId=${this.memberInfo.memberCenterId}&title=积分`
        );
        switch (data.helpingRedirectType) {
          case "1":
            URL_MINIPROGRAM = `plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=${data.helpingRedirectConfigContent}`;
            break;
          case "2":
            queryTwo = encodeURIComponent(
              `skuCode=${data.helpingRedirectConfigContent}&isScheme=1`
            );
            URL_MINIPROGRAM = `/subpackages/index/pages/productDetailsGlobal/product-details-global?skuCode=${data.helpingRedirectConfigContent}`;
            URL_ALIPAY = `alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/index/pages/productDetailsGlobal/product-details-global&query=${queryTwo}`;
            break;
          case "3":
            this.nextStep(data.helpingRedirectConfigContent, "2");
            break;
          case "4":
            URL_MINIPROGRAM = `/subpackages/my/pages/growthValue/growth-value?memberCenterId=${this.memberInfo.memberCenterId}&title=积分`;
            URL_ALIPAY = `alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/growthValue/growth-value?${query}`;
            break;
          case "5":
            URL_MINIPROGRAM =
              "/subpackages/my/pages/couponList/coupon-list?couponType=0";
            URL_ALIPAY =
              "alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/couponList/coupon-list";
            break;
          case "6":
            URL_MINIPROGRAM =
              "/subpackages/my/pages/couponList/coupon-list?couponType=1";
            // 支付宝无代金券
            URL_ALIPAY =
              "alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/couponList/coupon-list";
            break;
          case "7":
            URL_MINIPROGRAM = "/pages/tabBar/index/index";
            // 支付宝首页
            URL_ALIPAY =
              "alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index";
            break;
          default:
            break;
        }
        if (data.helpingRedirectType !== "3") {
          if (this.miniprogramFlag) {
            if (this.loginType === BWC.LoginType.Wechat) {
              // 微信小程序
              if (data.helpingRedirectType === "7") {
                wx.miniProgram.switchTab({
                  url: URL_MINIPROGRAM
                });
              } else {
                wx.miniProgram.navigateTo({
                  url: URL_MINIPROGRAM
                });
              }
            } else {
              // 支付宝小程序(支付宝不支持直播、代金券)
              if (data.helpingRedirectType === "7") {
                my.switchTab({
                  url: URL_MINIPROGRAM
                });
              } else {
                my.navigateTo({
                  url: URL_MINIPROGRAM
                });
              }
            }
          } else if (this.loginType === BWC.LoginType.Alipay) {
            // 支付宝H5(支付宝不支持直播、代金券)
            window.location.href = URL_ALIPAY;
          }
        }
      } else if (data.helpingRedirectMode === "2") {
        // 自定义链接
        this.nextStep(data.helpingRedirectConfigContent, "2");
      }
    },
    // 跳转 Hi荣耀 小程序
    goHiHonorMiniProgram(type) {
      if (this.loginType === BWC.LoginType.Wechat) {
        //在微信小程序环境打开
        if (type === "index") {
          wx.miniProgram.postMessage({
            activityUrl: encodeURIComponent(this.activityUrl)
          });
          wx.miniProgram.reLaunch({
            url:
              "/pages/tabBar/index/index?activityUrl=" +
              encodeURIComponent(this.activityUrl)
          });
        } else if (type === "my") {
          wx.miniProgram.switchTab({
            url: "/pages/tabBar/my/my"
          });
        } else if (type === "rewardQuery") {
          if (!this.isLoginFlag) {
            wx.miniProgram.postMessage({
              h5LoginToMiniFlag: !this.isLoginFlag || true
            });
            wx.miniProgram.reLaunch({
              url:
                "/pages/tabBar/index/index?activityUrl=" +
                encodeURIComponent(this.activityUrl),
              success: function() {
                console.log("跳转回小程序的页面success");
              },
              fail: function(res) {
                console.log("跳转回小程序的页面fail", res);
              }
            });
            return;
          } else {
            let url = "/subpackages/my/pages/rewardQuery/reward-query";
            if (!this.userBase || !this.userBase.member) {
              url += "?refresh=1";
            }
            wx.miniProgram.navigateTo({
              url: url
            });
          }
        }
      } else if (this.loginType === BWC.LoginType.Alipay) {
        //在支付宝小程序环境打开
        if (this.miniprogramFlag) {
          if (type === "index") {
            // 网页向小程序 postMessage 消息
            my.postMessage({
              activityUrl: encodeURIComponent(this.activityUrl)
            });
            my.reLaunch({
              url:
                "/pages/tabBar/index/index?activityUrl=" +
                encodeURIComponent(this.activityUrl)
            });
          } else if (type === "rewardQuery") {
            if (!this.isLoginFlag) {
              // 网页向小程序 postMessage 消息
              my.postMessage({
                activityUrl: encodeURIComponent(this.activityUrl)
              });
              my.reLaunch({
                url:
                  "/pages/tabBar/index/index?activityUrl=" +
                  encodeURIComponent(this.activityUrl)
              });
              return;
            } else {
              let url = "/subpackages/my/pages/rewardQuery/reward-query";
              if (!this.userBase || !this.userBase.member) {
                url += "?refresh=1";
              }
              my.navigateTo({
                url: url
              });
            }
          }
        } else {
          //在支付宝内部浏览器打开
          if (type === "index") {
            const query = "activityUrl=" + encodeURIComponent(this.activityUrl);
            window.location.href =
              "alipays://platformapi/startapp?appId=2021002121684220&page=pages/tabBar/index/index&query=" +
              query;
          } else if (type === "rewardQuery") {
            let url =
              "alipays://platformapi/startapp?appId=2021002121684220&page=subpackages/my/pages/rewardQuery/reward-query";
            if (!this.userBase) {
              url += "?refresh=1";
            } else if (!this.userBase.member) {
              url += "?refresh=1";
            }
            window.location.href = url;
          }
        }
      }
    },

    // 判断是否在小程序内
    handleMiniprogramJudge() {
      const that = this;
      if (this.loginType == BWC.LoginType.Wechat) {
        //判断是否在微信小程序环境
        wx.miniProgram.getEnv(function(res) {
          console.log("微信环境下", res);
          if (res.miniprogram) {
            that.miniprogramFlag = res.miniprogram;
          }
        });
      } else if (this.loginType == BWC.LoginType.Alipay) {
        loadAlipayWebViewScript().then(res => {
          console.log("支付宝环境下", res);
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.getEnv(function(res) {
              if (res.miniprogram) {
                that.miniprogramFlag = res.miniprogram;
              }
            });
          }
        });
      }
    },
    closeEnd(data) {
      this.showEndPage = data;
    },
    /**
     * 抽奖前置处理
     * 场景：PC端配置开启了“按时间段配中奖概率”，则需要根据经纬获取省份、区域的id，传入抽奖接口
     * @returns
     */
    beforeDrawHandler() {
      return new Promise(resolve => {
        const locationInfo =
          JSON.parse(sessionStorage.getItem("locationInfo")) || {};
        const longitude = locationInfo.longitude;
        const latitude = locationInfo.latitude;
        const coordinateType = locationInfo.coordinateType;
        // 传入了经纬度，且开启了按时间段配中奖概率，则需要查询抽奖前置接口
        if (
          longitude &&
          latitude &&
          coordinateType &&
          this.isTimeSectionLottery
        ) {
          const params = {
            longitude: longitude,
            dimension: latitude,
            coordinateType: coordinateType
          };
          this.$api.post({
            sc: "mobileMarketing",
            url: "/h5/navigationActivity/getProvincesCode",
            params: params,
            success: r => {
              if (r.code === 200) {
                const result = r.result || {};
                this.regionalId = result.regionalId;
                this.provincesRegionalId = result.provincesRegionalId;
                resolve(true);
              } else {
                resolve(r.message);
              }
            },
            failure: err => {
              resolve(err.toString());
            }
          });
        } else {
          resolve(true);
        }
      });
    },
    // 多门店活动，公用一条活动链接处理
    multipleStoreActivityHandler() {
      const locationInfo =
        JSON.parse(sessionStorage.getItem("locationInfo")) || {};
      this.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: `/h5/bigWheel/bigWheelActivityFront/${this.activityCode}`,
        params: {},
        success: res => {
          console.log("multipleStoreActivityHandler===>res: ", res);
          if (res.code === 200) {
            this.multiStoreActivityInfo = res.result || {};
            // 需要弹窗
            if (this.multiStoreActivityInfo.popUpFlag) {
              // 1.有门店信息，默认选择当前的门店即可
              if (this.multiStoreActivityInfo.channelFlag) {
                console.log(
                  "multipleStoreActivityHandler===>query",
                  this.$route.query
                );
                const shareChannelCode =
                  this.$route &&
                  this.$route.query &&
                  this.$route.query.shareChannelCode;
                const rewardChannelCode =
                  this.$route &&
                  this.$route.query &&
                  this.$route.query.rewardChannelCode;
                console.log(
                  "multipleStoreActivityHandler==>shareChannelCode",
                  shareChannelCode
                );
                const sessionStore = JSON.parse(
                  sessionStorage.getItem("currentStore")
                );
                // 1-1. 分享之后的刷新页面操作
                // 若和当前缓存的门店编码一致，则直接取缓存的门店
                if (
                  shareChannelCode &&
                  sessionStore.channelCode === shareChannelCode
                ) {
                  this.currentStore = sessionStore;
                  this.channelCode = sessionStore.channelCode;
                  this.confirmStore();
                } else if (rewardChannelCode) {
                  // 1-2. 奖励查询页跳转过来的，门店code查询门店信息
                  this.getStoreByChannelCode(rewardChannelCode);
                } else {
                  // 1-3. 上述条件都不满足，取接口返回的门店
                  this.currentStore = Object.assign({}, res.result);
                  delete this.currentStore.popUpFlag;
                  delete this.currentStore.channelFlag;
                  this.channelCode = this.currentStore.channelCode;
                  this.confirmStore();
                }
              } else if (Object.keys(locationInfo).length > 0) {
                // 2.没有门店信息，但是有经纬度信息，去查去查询门店，选择第一条数据，然后塞入门店信息到"顶部栏"和"门店确认弹窗"
                this.getNearestStore();
              } else {
                // 3.没有门店信息，且没有经纬度信息，需要拉起定位
                this.showGetLocationNotice = true;
              }
            }
          }
        }
      });
    },
    // 去获取定位
    async obtainLocation() {
      const positionInfo = await getPosition();
      this.getNearestStore();
    },
    // 导航到门店
    navToStore() {
      const storeInfo = {
        gcj02Latitude: this.currentStore.gcj02Latitude,
        gcj02Longitude: this.currentStore.gcj02Longitude,
        channelName: this.currentStore.channelName,
        channelAddress: this.currentStore.channelAddress,
        telephone: this.currentStore.telephone
      };
      jumpToMapNavigation(storeInfo, this.loginType);
    },
    // 去选择门店
    async selectStore() {
      const positionInfo = await getPosition();
      this.$refs.storeModal && this.$refs.storeModal.openModal(positionInfo);
    },
    // 确认当前默认的门店
    confirmStore() {
      console.log("confirmStore===>确认当前门店");
      sessionStorage.setItem("currentStore", JSON.stringify(this.currentStore));
      this.refreshActivityInfo();
      this.sendMessageToWebView();
    },
    // 切换门店
    changeStoreHandler(item) {
      console.log("changeStoreHandler===>item: ", item);
      this.currentStore = Object.assign({}, item);
      this.channelCode = item.channelCode;
      sessionStorage.setItem("currentStore", JSON.stringify(this.currentStore));
      this.sendMessageToWebView();
      this.refreshActivityInfo();
    },
    // 刷新活动信息
    refreshActivityInfo() {
      // 重置计数器
      this.refreshInterfaceCount = 0;
      this.totalRefreshInterface = 8;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 5000 // 默认值为5秒，设置为0，表示不会消失，需手动清除
      });
      this.getLotty();
      this.getAllData();
    },
    // 获取距离最近的活动门店
    getNearestStore() {
      const locationInfo =
        JSON.parse(sessionStorage.getItem("locationInfo")) || {};
      const param = {
        curPage: 1,
        pageSize: 1,
        filter: {
          activityCode: this.activityCode,
          longitude: locationInfo.longitude,
          dimension: locationInfo.latitude
        }
      };
      this.getStore(param);
    },
    // 给小程序webview发送消息
    sendMessageToWebView() {
      if (this.loginType === BWC.LoginType.Wechat) {
        console.log("sendMessageToWebView==>wechat");
        wx.miniProgram.postMessage({
          data: {
            channelCode: this.channelCode
          }
        });
      } else if (this.loginType === BWC.LoginType.Alipay) {
        my.postMessage({ channelCode: this.channelCode });
        console.log("sendMessageToWebView==>Alipay");
      }
    },
    // 通过门店编码获取门店信息
    getStoreByChannelCode(code) {
      if (code) {
        const param = {
          curPage: 1,
          pageSize: 10,
          filter: {
            activityCode: this.activityCode,
            channelCode: code
          }
        };
        this.getStore(param, true);
      }
    },
    // 查询门店
    getStore(param, isConfirm = false) {
      this.$api.post({
        noLoading: true,
        sc: "mobileMarketing",
        url: `/h5/bigWheel/selectChannelDetailByDraw`,
        params: param,
        success: res => {
          console.log("getStoreByChannelCode===>res: ", res);
          if (res && res.code === 200 && res.result[0]) {
            // 选择第一个门店
            const firstStore = res.result[0];
            this.currentStore.channelName = firstStore.channelName;
            this.currentStore.channelCode = firstStore.channelCode;
            this.currentStore.gcj02Longitude = firstStore.gcj02Longitude;
            this.currentStore.gcj02Latitude = firstStore.gcj02Latitude;
            this.currentStore.channelAddress = firstStore.channelAddress;
            this.currentStore.mobilephone = firstStore.mobilephone;
            // 更新门店编码
            this.channelCode = firstStore.channelCode;
            if (isConfirm) {
              this.confirmStore();
            } else {
              this.showSelectStoreNotice = true;
            }
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/page/vibrantRubikCube/runtime/lucky-draw/raffle-main.js